(() => {
  const BUILDER_CONTRACTS = Object.freeze({
    classic: Object.freeze({
      sourceProductId: 'cm87quc3b012spgzkrx5f50um',
      optionCounts: Object.freeze({ finish: 10, cloth: 12, sights: 8, 'table-size': 5, drawer: 2 }),
      fixedFeatures: Object.freeze({ wood: 'Tulip', legs: 'Tapered legs', pockets: 'Braided leather drop pockets' }),
      fixedPocketConstruction: 'leather',
      pocketCrop: Object.freeze({ x: 130, y: 6, width: 256, height: 256 })
    }),
    monarch: Object.freeze({
      sourceProductId: 'cm87qn6ep00dqpgzk5yf7geql',
      optionCounts: Object.freeze({ finish: 15, cloth: 12, sights: 8, 'table-size': 3, drawer: 2 }),
      fixedFeatures: Object.freeze({ wood: 'Maple and Oak', legs: 'Pedestal base', pockets: 'Fixed source-rendered pockets' }),
      pocketCrop: Object.freeze({ x: 130, y: 6, width: 256, height: 256 })
    }),
    'waterfall-pool-table': Object.freeze({
      sourceProductId: 'cm87qos4g00ihpgzk97ra7c9m',
      optionCounts: Object.freeze({ finish: 16, cloth: 12, sights: 8, 'table-size': 1 }),
      fixedFeatures: Object.freeze({ wood: 'Maple', legs: 'Curved pedestal base', pockets: 'Fixed source-rendered pockets' }),
      pocketCrop: Object.freeze({ x: 100, y: 0, width: 256, height: 256 })
    }),
    'west-end-pool-table': Object.freeze({
      sourceProductId: 'cm87qpdov00k6pgzkqpvqij8z',
      optionCounts: Object.freeze({ finish: 15, cloth: 12, sights: 8, 'table-size': 3, drawer: 2 }),
      fixedFeatures: Object.freeze({ wood: 'Maple and Oak', legs: 'Squared pedestal base', pockets: 'Fixed source-rendered pockets' })
    }),
    metro: Object.freeze({
      sourceProductId: 'cm87qxgcb018lpgzkyp8qu3jp',
      optionCounts: Object.freeze({ finish: 14, cloth: 12, sights: 8, 'table-size': 3, drawer: 2 }),
      fixedFeatures: Object.freeze({ pockets: 'Leather drop pockets with braided fringe' }),
      fixedPocketConstruction: 'leather',
      pocketCrop: Object.freeze({ x: 130, y: 6, width: 256, height: 256 })
    }),
    americana: Object.freeze({
      sourceProductId: 'cm87qstwa00wjpgzke0rh4mpg',
      optionCounts: Object.freeze({ finish: 5, cloth: 12, sights: 1, 'table-size': 2 }),
      fixedFeatures: Object.freeze({ wood: 'Tulip', legs: 'Queen Anne-style legs', pockets: 'Braided leather drop pockets' }),
      fixedPocketConstruction: 'leather',
      pocketCrop: Object.freeze({ x: 130, y: 6, width: 256, height: 256 })
    }),
    augusta: Object.freeze({
      sourceProductId: 'cm87qt08z00x4pgzk2v3c2gsx',
      optionCounts: Object.freeze({ finish: 14, cloth: 12, sights: 8, 'table-size': 1, drawer: 2 }),
      fixedFeatures: Object.freeze({ pockets: 'Leather drop pockets with braided fringe' }),
      fixedPocketConstruction: 'leather',
      pocketBackingRequired: true,
      pocketCrop: Object.freeze({ x: 130, y: 6, width: 256, height: 256 })
    }),
    brentwood: Object.freeze({
      sourceProductId: 'cm87qtpyn0107pgzk27twbndz',
      optionCounts: Object.freeze({ finish: 14, cloth: 12, sights: 8, 'table-size': 1, drawer: 2 }),
      fixedFeatures: Object.freeze({ pockets: 'Fixed source-rendered pockets' }),
      pocketBackingRequired: true,
      pocketCrop: Object.freeze({ x: 130, y: 6, width: 256, height: 256 })
    }),
    chicago: Object.freeze({
      sourceProductId: 'cm87qu14v011gpgzkth5d9o1e',
      optionCounts: Object.freeze({ finish: 14, cloth: 12, sights: 8, 'table-size': 2, drawer: 2 }),
      fixedFeatures: Object.freeze({ wood: 'Maple', legs: 'Saber legs', pockets: 'Leather drop pockets with woven netting' }),
      fixedPocketConstruction: 'leather',
      pocketBackingRequired: true,
      pocketCrop: Object.freeze({ x: 130, y: 6, width: 256, height: 256 })
    }),
    railyard: Object.freeze({
      sourceProductId: 'cm87qqs8000oqpgzkmkzj1e4l',
      optionCounts: Object.freeze({ finish: 1, cloth: 12, sights: 1, 'table-size': 3, drawer: 2 }),
      fixedFeatures: Object.freeze({ pockets: 'Fixed source-rendered pockets' }),
      pocketCrop: Object.freeze({ x: 120, y: 0, width: 256, height: 256 })
    }),
    'palazzo-pool-table': Object.freeze({
      sourceProductId: 'cmcwg9yyk0006jp04hi3boyk4',
      optionCounts: Object.freeze({ finish: 15, cloth: 12, sights: 8, 'table-size': 2, drawer: 2 }),
      fixedFeatures: Object.freeze({ wood: 'Maple', legs: 'Powder-coated aluminum legs', pockets: 'Fixed source-rendered pockets' }),
      pocketCrop: Object.freeze({ x: 120, y: 0, width: 256, height: 256 })
    }),
    belmont: Object.freeze({
      sourceProductId: 'cm87qtbvv00yhpgzkhp0x2vzd',
      optionCounts: Object.freeze({ finish: 5, cloth: 12, sights: 1, 'table-size': 2 }),
      fixedFeatures: Object.freeze({ wood: 'Solid Tulipwood', legs: 'Classic tapered legs', pockets: 'Braided leather drop pockets' }),
      fixedPocketConstruction: 'leather',
      pocketBackingRequired: true,
      pocketCrop: Object.freeze({ x: 130, y: 6, width: 256, height: 256 })
    }),
    sheraton: Object.freeze({
      sourceProductId: 'cm87qzhzy01eopgzkcv0f19x4',
      optionCounts: Object.freeze({ finish: 1, cloth: 12, sights: 1, 'table-size': 2 }),
      fixedFeatures: Object.freeze({ wood: 'Black Laminate', legs: 'Squared legs', pockets: 'Fixed source-rendered pockets' }),
      pocketBackingRequired: true,
      pocketCrop: Object.freeze({ x: 100, y: 0, width: 256, height: 256 })
    }),
    'sheraton-1': Object.freeze({
      sourceProductId: 'cm87qz6g301drpgzkhf42ayum',
      optionCounts: Object.freeze({ finish: 9, cloth: 12, sights: 8, 'table-size': 2, drawer: 2 }),
      fixedFeatures: Object.freeze({ wood: 'Tulip', pockets: 'Fixed source-rendered pockets' }),
      pocketBackingRequired: true,
      pocketCrop: Object.freeze({ x: 100, y: 0, width: 256, height: 256 })
    }),
    'reno-1': Object.freeze({
      sourceProductId: 'cm87qyb0j01b8pgzkgttmfzq7',
      optionCounts: Object.freeze({ finish: 11, cloth: 12, sights: 8, 'table-size': 2, drawer: 2 }),
      fixedFeatures: Object.freeze({ wood: 'Tulip', pockets: 'Fixed source-rendered pockets' }),
      pocketBackingRequired: true,
      pocketCrop: Object.freeze({ x: 100, y: 0, width: 256, height: 256 })
    }),
    'santa-ana': Object.freeze({
      sourceProductId: 'cm87qyr4u01cfpgzkf9qxem8j',
      optionCounts: Object.freeze({ finish: 14, cloth: 12, sights: 8, 'table-size': 2, drawer: 2 }),
      fixedFeatures: Object.freeze({ pockets: 'Fixed source-rendered pockets' }),
      pocketBackingRequired: true,
      pocketCrop: Object.freeze({ x: 100, y: 0, width: 256, height: 256 })
    }),
    encore: Object.freeze({
      sourceProductId: 'cmekfta5f0001lb04r08h467v',
      optionCounts: Object.freeze({ finish: 15, cloth: 12, sights: 8, 'table-size': 3, drawer: 2 }),
      fixedFeatures: Object.freeze({ pockets: 'Fixed source-rendered pockets' }),
      pocketBackingRequired: true,
      pocketCrop: Object.freeze({ x: 100, y: 0, width: 256, height: 256 })
    }),
    seville: Object.freeze({
      sourceProductId: 'cm87qr9j600qapgzk7fuljmep',
      optionCounts: Object.freeze({ finish: 14, cloth: 12, sights: 6, 'table-size': 2, drawer: 1 }),
      fixedFeatures: Object.freeze({ pockets: 'Fixed source-rendered pockets' }),
      pocketBackingRequired: true,
      pocketCrop: Object.freeze({ x: 100, y: 0, width: 256, height: 256 })
    }),
    laguna: Object.freeze({
      sourceProductId: 'cm87qkabp005npgzkg06dfjd1',
      optionCounts: Object.freeze({ finish: 15, cloth: 12, sights: 8, 'table-size': 3, drawer: 2 }),
      fixedFeatures: Object.freeze({ pockets: 'Fixed source-rendered pockets' }),
      pocketBackingRequired: true,
      pocketCrop: Object.freeze({ x: 100, y: 0, width: 256, height: 256 })
    }),
    'harley-davidson-maple': Object.freeze({
      sourceProductId: 'cm87qqa8k00n3pgzkjmzkzrqw',
      optionCounts: Object.freeze({ finish: 5, cloth: 12, 'table-size': 3 }),
      fixedFeatures: Object.freeze({
        wood: 'Maple',
        sights: 'Harley-Davidson™ Chrome Sights and Harley-Davidson™ Laser Logo on Rail',
        pockets: 'Fixed source-rendered pockets'
      }),
      fixedSight: Object.freeze({ id: 'harley-davidson-chrome', label: 'Harley-Davidson™ Chrome Sight' }),
      pocketBackingRequired: true,
      pocketCrop: Object.freeze({ x: 100, y: 0, width: 256, height: 256 })
    }),
    youngstown: Object.freeze({
      sourceProductId: 'cm87qr5wo00pypgzky12cbwyy',
      optionCounts: Object.freeze({ finish: 8, cloth: 12, sights: 9, 'table-size': 3, drawer: 2 }),
      fixedFeatures: Object.freeze({ wood: 'Oak', pockets: 'Fixed source-rendered pockets' }),
      pocketBackingRequired: true,
      pocketCrop: Object.freeze({ x: 100, y: 0, width: 256, height: 256 })
    }),
    'oceanside-pool-table': Object.freeze({
      sourceProductId: 'cmbqvvqh40001js04bbl3kvnj',
      optionCounts: Object.freeze({ finish: 7, cloth: 12, sights: 8, 'table-size': 3, drawer: 2 }),
      fixedFeatures: Object.freeze({ wood: 'Maple and Oak', legs: 'Wide rounded forms', pockets: 'Fixed source-rendered pockets' }),
      compatibilityRuleCount: 1,
      finishSampleMode: 'robust-visible-finish',
      pocketCrop: Object.freeze({ x: 310, y: 0, width: 256, height: 256 })
    }),
    southern: Object.freeze({
      sourceProductId: 'cmsqddxje000005jk9ydz0xz9',
      optionCounts: Object.freeze({ finish: 9, cloth: 12, sights: 8, 'table-size': 2, drawer: 2 }),
      fixedFeatures: Object.freeze({ wood: 'Tulip', legs: 'Thick square legs', pockets: 'Fixed source-rendered pockets' }),
      pocketBackingRequired: true,
      pocketCrop: Object.freeze({ x: 100, y: 0, width: 256, height: 256 })
    }),
    hampton: Object.freeze({
      sourceProductId: 'cm87qv92e013rpgzk7g8stfzq',
      optionCounts: Object.freeze({ finish: 9, cloth: 12, sights: 8, 'table-size': 3, drawer: 2 }),
      fixedFeatures: Object.freeze({ wood: 'Tulip', legs: 'Carved legs with fluted accents', pockets: 'Fixed source-rendered pockets' }),
      pocketBackingRequired: true,
      pocketCrop: Object.freeze({ x: 130, y: 6, width: 256, height: 256 })
    }),
    heritage: Object.freeze({
      sourceProductId: 'cm87qjvt4004bpgzk6hw27j2o',
      optionCounts: Object.freeze({ finish: 15, cloth: 12, sights: 9, 'table-size': 2, drawer: 2 }),
      fixedFeatures: Object.freeze({ wood: 'Maple', legs: 'Pedestal base with brushed aluminum trim', pockets: 'Fixed source-rendered pockets' }),
      pocketBackingRequired: true,
      pocketCrop: Object.freeze({ x: 130, y: 6, width: 256, height: 256 })
    }),
    'st-george': Object.freeze({
      sourceProductId: 'cm87qrted00slpgzkw6vjqxzu',
      optionCounts: Object.freeze({ finish: 11, cloth: 12, sights: 6, 'table-size': 2, drawer: 1 }),
      fixedFeatures: Object.freeze({ wood: 'Maple', legs: 'Hand-carved legs', pockets: 'Fixed source-rendered pockets' }),
      pocketBackingRequired: true,
      pocketCrop: Object.freeze({ x: 100, y: 0, width: 256, height: 256 })
    }),
    'st-andrews': Object.freeze({
      sourceProductId: 'cm87qrj0d00rfpgzktfs8a56o',
      optionCounts: Object.freeze({ finish: 14, cloth: 12, sights: 6, 'table-size': 2, drawer: 1 }),
      fixedFeatures: Object.freeze({ wood: 'Maple', legs: 'Ornate carved legs with scrollwork', pockets: 'Fixed source-rendered pockets' }),
      pocketBackingRequired: true,
      pocketCrop: Object.freeze({ x: 100, y: 0, width: 256, height: 256 })
    }),
    tustin: Object.freeze({
      sourceProductId: 'cm87qr0bm00papgzkvaysj607',
      optionCounts: Object.freeze({ finish: 6, cloth: 12, sights: 8, 'table-size': 3, drawer: 2 }),
      fixedFeatures: Object.freeze({ wood: 'Maple or Oak', legs: 'X-shaped pedestal legs with metal crossbar', pockets: 'Fixed source-rendered pockets' }),
      pocketBackingRequired: true,
      pocketCrop: Object.freeze({ x: 100, y: 0, width: 256, height: 256 })
    }),
    'st-leone': Object.freeze({
      sourceProductId: 'cm87qs3r300trpgzk915kthns',
      optionCounts: Object.freeze({ finish: 14, cloth: 12, sights: 6, 'table-size': 2, drawer: 1 }),
      fixedFeatures: Object.freeze({ wood: 'Maple', legs: 'Hand-sculpted ornate legs', pockets: 'Fixed source-rendered pockets' }),
      pocketBackingRequired: true,
      pocketCrop: Object.freeze({ x: 100, y: 0, width: 256, height: 256 })
    }),
    luxor: Object.freeze({
      sourceProductId: 'cm87ql5er0087pgzki17030zs',
      optionCounts: Object.freeze({ finish: 15, cloth: 12, sights: 9, 'table-size': 1, drawer: 2 }),
      fixedFeatures: Object.freeze({ material: 'Maple or Brushed Aluminum', legs: 'Pedestal base legs in brushed aluminum', pockets: 'Fixed source-rendered pockets' }),
      pocketBackingRequired: true,
      pocketCrop: Object.freeze({ x: 130, y: 6, width: 256, height: 256 })
    }),
    venetian: Object.freeze({
      sourceProductId: 'cm87qsdwy00uwpgzkqv796sx0',
      optionCounts: Object.freeze({ finish: 14, cloth: 12, sights: 6, 'table-size': 2, drawer: 1 }),
      fixedFeatures: Object.freeze({ wood: 'Maple', pockets: 'Fixed source-rendered pockets' }),
      pocketCrop: Object.freeze({ x: 100, y: 0, width: 256, height: 256 })
    }),
    remington: Object.freeze({
      sourceProductId: 'cmrl4eme3000004l86txrkqqp',
      optionCounts: Object.freeze({ finish: 14, cloth: 12, sights: 8, 'table-size': 2, drawer: 1 }),
      fixedFeatures: Object.freeze({ wood: 'Maple', pockets: 'Fixed source-rendered pockets' }),
      pocketBackingRequired: true,
      pocketCrop: Object.freeze({ x: 100, y: 0, width: 256, height: 256 })
    }),
    york: Object.freeze({
      sourceProductId: 'cm87qpt5z00llpgzk2voxtbh7',
      optionCounts: Object.freeze({ finish: 13, cloth: 12, sights: 8, 'table-size': 3, drawer: 2 }),
      fixedFeatures: Object.freeze({ wood: 'Maple', legs: 'Wide block legs with a subtle curve', pockets: 'Fixed source-rendered pockets' }),
      pocketBackingRequired: true,
      compatibilityRuleCount: 1,
      pocketCrop: Object.freeze({ x: 100, y: 0, width: 256, height: 256 })
    }),
    'timber-ridge': Object.freeze({
      sourceProductId: 'cm87qqwin00p1pgzkp51tq49z',
      optionCounts: Object.freeze({ finish: 1, cloth: 12, sights: 1, 'table-size': 1 }),
      fixedFeatures: Object.freeze({ wood: 'Pine', legs: 'Wide square legs with angled braces', pockets: 'Leather drop pockets with braided netting' }),
      fixedPocketConstruction: 'leather',
      pocketBackingRequired: true,
      pocketCrop: Object.freeze({ x: 100, y: 0, width: 256, height: 256 })
    }),
    'grand-champion-iii': Object.freeze({
      sourceProductId: 'cm87qsq3a00w7pgzkq1vjy0ua',
      optionCounts: Object.freeze({ finish: 1, cloth: 12, sights: 1, 'table-size': 3 }),
      fixedFeatures: Object.freeze({ material: 'Black Laminate', pockets: 'Fixed source-rendered tournament pockets' }),
      pocketBackingRequired: true,
      finishSampleMode: 'robust-visible-finish',
      pocketCrop: Object.freeze({ x: 0, y: 0, width: 256, height: 256 })
    }),
    blackhawk: Object.freeze({
      sourceProductId: 'cm87qtg9m00z1pgzkpu3icshm',
      optionCounts: Object.freeze({ finish: 1, cloth: 12, sights: 1, 'table-size': 3, drawer: 2 }),
      fixedFeatures: Object.freeze({ wood: 'Tulip', legs: 'Clawfoot legs', pockets: 'Leather drop pockets' }),
      fixedPocketConstruction: 'leather',
      pocketBackingRequired: true,
      pocketCrop: Object.freeze({ x: 130, y: 6, width: 256, height: 256 })
    }),
    breckenridge: Object.freeze({
      sourceProductId: 'cm87qqgdz00nspgzk1ou3jwge',
      optionCounts: Object.freeze({ finish: 1, cloth: 12, sights: 1, 'table-size': 3, drawer: 2 }),
      fixedFeatures: Object.freeze({ wood: 'Pine', legs: 'Thick square legs with horizontal supports', pockets: 'Fixed source-rendered pockets' }),
      pocketCrop: Object.freeze({ x: 40, y: 0, width: 256, height: 256 })
    }),
    durango: Object.freeze({
      sourceProductId: 'cm87qql5u00o3pgzk98hawngl',
      optionCounts: Object.freeze({ finish: 1, cloth: 12, sights: 1, 'table-size': 3, drawer: 2 }),
      fixedFeatures: Object.freeze({ wood: 'Pine', legs: 'Wide crisscrossed X-shaped legs', pockets: 'Fixed source-rendered pockets' }),
      pocketCrop: Object.freeze({ x: 40, y: 0, width: 256, height: 256 })
    }),
    regent: Object.freeze({
      sourceProductId: 'cm87qo1ub00gfpgzkjht4cvd8',
      optionCounts: Object.freeze({ finish: 2, cloth: 12, sights: 1, 'table-size': 2, drawer: 2 }),
      fixedFeatures: Object.freeze({ material: 'Laminate', pockets: 'Fixed source-rendered pockets' }),
      finishSampleMode: 'robust-visible-finish',
      pocketCrop: Object.freeze({ x: 544, y: 0, width: 256, height: 256 })
    })
  });

  const isHexColor = (value) => typeof value === 'string' && /^#[0-9a-f]{6}$/i.test(value);
  const isString = (value) => typeof value === 'string' && value.trim().length > 0;
  const SIGHT_DETAIL_MAX_AXIS_RATIO = 0.5;
  const SIGHT_DETAIL_OVERLAY_CENTER = Object.freeze({ x: 192, y: 192 });
  const SIGHT_DETAIL_SOURCE_MARK_CENTERS = Object.freeze([
    Object.freeze({ x: 337.875, y: 96.875 }),
    Object.freeze({ x: 408.5, y: 88.5 }),
    Object.freeze({ x: 474, y: 80.25 })
  ]);
  const RAIL_TOP_SAMPLE = Object.freeze({
    minX: 310,
    maxX: 506,
    anchorX: 337.875,
    anchorY: 96.875,
    angleRadians: -0.12152854644878998,
    halfNormalWidth: 7,
    excludedSightRadius: 8,
    sightCenters: SIGHT_DETAIL_SOURCE_MARK_CENTERS
  });
  const SIGHT_DETAIL_READY_HANDLES = new Set([
    'classic', 'monarch', 'waterfall-pool-table', 'west-end-pool-table', 'metro', 'americana', 'augusta', 'brentwood', 'chicago', 'railyard',
    'palazzo-pool-table', 'belmont', 'sheraton', 'sheraton-1', 'reno-1', 'santa-ana', 'encore', 'seville', 'southern',
    'hampton', 'heritage', 'st-george', 'st-andrews', 'tustin', 'st-leone', 'luxor',
    'remington', 'york', 'timber-ridge', 'grand-champion-iii', 'blackhawk', 'breckenridge', 'durango', 'regent', 'oceanside-pool-table', 'youngstown', 'laguna', 'harley-davidson-maple', 'venetian'
  ]);
  const SIGHT_DETAIL_FAIL_CLOSED_REASONS = Object.freeze({});
  const POCKET_DETAIL_SOURCE_SIZE = 256;
  const POCKET_MASK_ALPHA_THRESHOLD = 192;
  // Target coordinates are measured in each model's 256px official corner crop.
  // They fit the visible pocket-opening envelope rather than a shared/generic pocket size.
  const POCKET_INSTALLATIONS = Object.freeze({
    classic: Object.freeze({ target: Object.freeze({ x: 79, y: 96, width: 68, height: 98 }), skewX: -0.02, maskPadding: 0 }),
    americana: Object.freeze({ target: Object.freeze({ x: 80, y: 94, width: 74, height: 90 }), skewX: -0.02, maskPadding: 0 }),
    augusta: Object.freeze({ target: Object.freeze({ x: 76, y: 96, width: 82, height: 90 }), skewX: -0.02, maskPadding: 0 }),
    brentwood: Object.freeze({ target: Object.freeze({ x: 76, y: 96, width: 82, height: 92 }), skewX: -0.02, maskPadding: 0 }),
    chicago: Object.freeze({ target: Object.freeze({ x: 76, y: 96, width: 82, height: 90 }), skewX: -0.02, maskPadding: 0 }),
    belmont: Object.freeze({ target: Object.freeze({ x: 80, y: 94, width: 74, height: 90 }), skewX: -0.02, maskPadding: 0 }),
    sheraton: Object.freeze({ target: Object.freeze({ x: 106, y: 102, width: 72, height: 88 }), skewX: -0.02, maskPadding: 0 }),
    'sheraton-1': Object.freeze({ target: Object.freeze({ x: 106, y: 102, width: 72, height: 88 }), skewX: -0.02, maskPadding: 0 }),
    'reno-1': Object.freeze({ target: Object.freeze({ x: 106, y: 102, width: 72, height: 88 }), skewX: -0.02, maskPadding: 0 }),
    'santa-ana': Object.freeze({ target: Object.freeze({ x: 108, y: 91, width: 68, height: 98 }), skewX: -0.02, maskPadding: 0 }),
    seville: Object.freeze({ target: Object.freeze({ x: 110, y: 102, width: 68, height: 82 }), skewX: -0.02, maskPadding: 0 }),
    southern: Object.freeze({ target: Object.freeze({ x: 106, y: 103, width: 74, height: 106 }), skewX: -0.02, maskPadding: 0 }),
    hampton: Object.freeze({ target: Object.freeze({ x: 80, y: 100, width: 68, height: 80 }), skewX: -0.02, maskPadding: 0 }),
    'st-george': Object.freeze({ target: Object.freeze({ x: 110, y: 102, width: 68, height: 86 }), skewX: -0.02, maskPadding: 0 }),
    'st-andrews': Object.freeze({ target: Object.freeze({ x: 110, y: 102, width: 68, height: 84 }), skewX: -0.02, maskPadding: 0 }),
    'st-leone': Object.freeze({ target: Object.freeze({ x: 109, y: 102, width: 68, height: 88 }), skewX: -0.02, maskPadding: 0 }),
    venetian: Object.freeze({ target: Object.freeze({ x: 109, y: 102, width: 68, height: 88 }), skewX: -0.02, maskPadding: 0 }),
    remington: Object.freeze({ target: Object.freeze({ x: 110, y: 96, width: 68, height: 100 }), skewX: -0.02, maskPadding: 0 }),
    'timber-ridge': Object.freeze({ target: Object.freeze({ x: 106, y: 89, width: 74, height: 106 }), skewX: -0.02, maskPadding: 0 }),
    blackhawk: Object.freeze({ target: Object.freeze({ x: 80, y: 94, width: 74, height: 90 }), skewX: -0.02, maskPadding: 0 }),
    metro: Object.freeze({ target: Object.freeze({ x: 80, y: 94, width: 74, height: 90 }), skewX: -0.02, maskPadding: 0 })
  });
  const DETAIL_COLOR_DELTA_E_MAX = 2;
  const ROBUST_LUMINANCE_TRIM = 0.15;

  const clamp = (value, minimum, maximum) => Math.min(maximum, Math.max(minimum, value));
  const median = (values) => {
    if (values.length === 0) throw new Error('Cannot calculate a median from an empty sample.');
    const sorted = [...values].sort((left, right) => left - right);
    const middle = Math.floor(sorted.length / 2);
    return sorted.length % 2 === 0 ? (sorted[middle - 1] + sorted[middle]) / 2 : sorted[middle];
  };
  const srgbToLinear = (channel) => {
    const normalized = channel / 255;
    return normalized <= 0.04045 ? normalized / 12.92 : ((normalized + 0.055) / 1.055) ** 2.4;
  };
  const linearToSrgb = (channel) => {
    const normalized = channel <= 0.0031308 ? channel * 12.92 : 1.055 * (channel ** (1 / 2.4)) - 0.055;
    return Math.round(clamp(normalized, 0, 1) * 255);
  };
  const rgbToLab = (red, green, blue) => {
    const r = srgbToLinear(red);
    const g = srgbToLinear(green);
    const b = srgbToLinear(blue);
    const x = (r * 0.4124564 + g * 0.3575761 + b * 0.1804375) / 0.95047;
    const y = r * 0.2126729 + g * 0.7151522 + b * 0.072175;
    const z = (r * 0.0193339 + g * 0.119192 + b * 0.9503041) / 1.08883;
    const transform = (value) => value > 0.008856 ? Math.cbrt(value) : 7.787 * value + 16 / 116;
    const fx = transform(x);
    const fy = transform(y);
    const fz = transform(z);
    return { l: 116 * fy - 16, a: 500 * (fx - fy), b: 200 * (fy - fz) };
  };
  const labToRgb = ({ l, a, b }) => {
    const fy = (l + 16) / 116;
    const fx = a / 500 + fy;
    const fz = fy - b / 200;
    const inverse = (value) => {
      const cubed = value ** 3;
      return cubed > 0.008856 ? cubed : (value - 16 / 116) / 7.787;
    };
    const x = 0.95047 * inverse(fx);
    const y = inverse(fy);
    const z = 1.08883 * inverse(fz);
    return {
      red: linearToSrgb(x * 3.2404542 + y * -1.5371385 + z * -0.4985314),
      green: linearToSrgb(x * -0.969266 + y * 1.8760108 + z * 0.041556),
      blue: linearToSrgb(x * 0.0556434 + y * -0.2040259 + z * 1.0572252)
    };
  };
  const deltaE76 = (left, right) => Math.hypot(left.l - right.l, left.a - right.a, left.b - right.b);
  const labString = ({ l, a, b }) => `${l.toFixed(4)},${a.toFixed(4)},${b.toFixed(4)}`;
  const rgbHex = ({ red, green, blue }) => `#${red.toString(16).padStart(2, '0')}${green.toString(16).padStart(2, '0')}${blue.toString(16).padStart(2, '0')}`;

  class ClassicBuilderPrototype extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.stage = this.querySelector('[data-classic-stage]');
      this.finishReference = this.querySelector('[data-classic-finish-reference]');
      this.feltLayer = this.querySelector('[data-classic-felt-layer]');
      this.pocketUnderlay = this.querySelector('[data-classic-pocket-underlay]');
      this.drawerLayer = this.querySelector('[data-classic-drawer-layer]');
      this.viewerStatus = this.querySelector('[data-classic-viewer-status]');
      this.optionGroups = this.querySelector('[data-classic-option-groups]');
      this.visualOptionGroups = this.querySelector('[data-classic-visual-option-groups]');
      this.productDetailsSlot = this.querySelector('[data-classic-product-details-slot]');
      this.quoteWorkspace = this.querySelector('[data-classic-quote-workspace]');
      this.quoteSlot = this.querySelector('[data-classic-quote-slot]');
      this.summary = this.querySelector('[data-classic-summary]');
      this.validationStatus = this.querySelector('[data-classic-validation-status]');
      this.useButton = this.querySelector('[data-classic-use-configuration]');
      this.commitStatus = this.querySelector('[data-classic-commit-status]');
      this.error = this.querySelector('[data-classic-error]');
      this.pocketCard = this.querySelector('[data-classic-pocket-card]');
      this.pocketDetail = this.querySelector('[data-classic-pocket-detail]');
      this.pocketCaption = this.querySelector('[data-classic-pocket-caption]');
      this.pocketFixedNote = this.querySelector('[data-classic-pocket-fixed-note]');
      this.feltCard = this.querySelector('[data-classic-felt-card]');
      this.feltDetail = this.querySelector('[data-classic-felt-detail]');
      this.detailFeltCaption = this.querySelector('[data-classic-detail-felt-caption]');
      this.feltFixedNote = this.querySelector('[data-classic-felt-fixed-note]');
      this.sightCard = this.querySelector('[data-classic-sight-card]');
      this.sightDetail = this.querySelector('[data-classic-sight-detail]');
      this.detailSightCaption = this.querySelector('[data-classic-detail-sight-caption]');
      this.sightFixedNote = this.querySelector('[data-classic-sight-fixed-note]');
      this.selectedSurfaces = this.querySelector('[data-classic-selected-surfaces]');
      this.fixedDetails = this.querySelector('[data-classic-fixed-details]');
      this.model = this.parseModel();
      this.contract = BUILDER_CONTRACTS[this.dataset.productHandle];
      this.visualManifest = this.parseVisualManifest();
      this.applyVisualManifest();
      this.applyDrawerSelectionGate();
      this.pocketCatalog = this.parsePocketCatalog();
      this.applyPocketCatalog();
      this.selectablePocketVisualEnabled = this.model.pocketOptionEvidence?.selectable === true
        && this.model.options?.some((option) => ['pockets', 'pocket-style'].includes(option.id) && option.values?.length > 1);
      this.fixedPocketDetail = null;
      this.fixedPocketVisualEnabled = false;
      this.pocketVisualEnabled = this.selectablePocketVisualEnabled;
      if (this.pocketCard && !this.pocketVisualEnabled) {
        this.pocketCard.remove();
        this.pocketCard = null;
        this.pocketDetail = null;
        this.pocketCaption = null;
        this.pocketFixedNote = null;
      } else if (this.pocketCard) {
        this.pocketCard.hidden = false;
      }
      this.state = { ...(this.model.defaults || {}) };
      this.viewerReady = true;
      this.viewerFailed = false;
      this.catalogErrors = this.validateCatalog();
      const requiredDetailMarkup = [this.feltCard, this.feltDetail, this.sightCard, this.sightDetail];
      if (this.pocketVisualEnabled) requiredDetailMarkup.push(this.pocketCard, this.pocketDetail);
      if (requiredDetailMarkup.some((element) => !element)) {
        this.catalogErrors.push('detail_card_markup_missing');
      }
      if (this.contract?.pocketBackingRequired === true && !this.pocketUnderlay) {
        this.catalogErrors.push('pocket_underlay_markup_missing');
      }
      if (!this.drawerLayer) this.catalogErrors.push('drawer_layer_markup_missing');
      if (this.catalogErrors.length > 0) this.dataset.errorCodes = this.catalogErrors.join(',');
      this.visualImageCache = new Map();
      this.imageAlphaBoundsCache = new Map();
      this.imageDataCache = new Map();
      this.enclosedBedIndexCache = new Map();
      this.detailColorTargetCache = new Map();
      this.textureLuminanceProfileCache = new Map();
      this.detailRenderToken = 0;
      this.drawerPreviewToken = 0;

      this.restoreState();
      this.bindActions();
      this.renderOptions();
      this.mountProductDetails();
      this.updateFixedDetailNotes();
      this.renderFixedDetails();
      this.update({ applyPreview: true });

      if (this.catalogErrors.length > 0) {
        this.fail(`The ${this.model.product?.title || 'pool table'} configurator data did not pass its exact-product validation gate.`);
        return;
      }

      this.preloadVisualImages();
      this.stage.dataset.ready = 'true';
      this.stage.setAttribute('aria-busy', 'false');
    }

    parseModel() {
      const script = this.querySelector('[data-classic-configuration-model]');
      if (!script) return {};

      try {
        return JSON.parse(script.textContent);
      } catch (error) {
        return {};
      }
    }

    mountProductDetails() {
      if (!this.classList.contains('classic-builder--layout-pilot') || !this.productDetailsSlot) return;

      const details = document.querySelector('.shopify-section--game-room-product-details .game-room-product-details');
      if (!details || this.contains(details)) {
        this.productDetailsSlot.hidden = true;
        if (!details && document.readyState === 'loading' && this.dataset.productDetailsRetryBound !== 'true') {
          this.dataset.productDetailsRetryBound = 'true';
          document.addEventListener('DOMContentLoaded', () => this.mountProductDetails(), { once: true });
        }
        return;
      }

      const sourceSection = details.closest('.shopify-section--game-room-product-details');
      details.classList.add('game-room-product-details--classic-builder-pilot');
      this.productDetailsSlot.append(details);
      this.productDetailsSlot.hidden = false;
      if (sourceSection) sourceSection.hidden = true;
    }

    parseVisualManifest() {
      const script = this.querySelector('[data-pool-table-visual-manifest]');
      if (!script) return null;

      try {
        return JSON.parse(script.textContent);
      } catch (error) {
        return {};
      }
    }

    applyDrawerSelectionGate() {
      const options = Array.isArray(this.model.options) ? this.model.options : [];
      const drawerIndex = options.findIndex((option) => option.id === 'drawer');
      const drawerOption = drawerIndex >= 0 ? options[drawerIndex] : null;
      const eligibleValues = drawerOption?.values?.filter((value) => value.eligible === true) || [];
      const eligibleValueIds = new Set(eligibleValues.map((value) => value.id));
      this.drawerSelectable = Boolean(
        drawerOption
        && drawerOption.values?.length === 2
        && eligibleValues.length === 2
        && eligibleValueIds.has('no')
        && eligibleValueIds.has('yes')
        && isString(drawerOption.sourceOptionId)
      );

      if (this.drawerSelectable) return;

      if (drawerIndex >= 0) options.splice(drawerIndex, 1);
      this.model.options = options;
      if (this.model.defaults) delete this.model.defaults.drawer;
      if (this.model.defaultEvidence) delete this.model.defaultEvidence.drawer;
      if (this.model.compatibilityMatrix?.allowedSourceValueIdsByOption) {
        delete this.model.compatibilityMatrix.allowedSourceValueIdsByOption.drawer;
      }
      this.model.compatibilityRules = (this.model.compatibilityRules || []).filter((rule) => (
        rule.when?.optionId !== 'drawer'
        && !(rule.blocks || []).some((blocked) => blocked.optionId === 'drawer')
      ));
    }

    parsePocketCatalog() {
      const script = this.querySelector('[data-olhausen-pocket-options]');
      if (!script) return null;

      try {
        return JSON.parse(script.textContent);
      } catch (error) {
        return {};
      }
    }

    applyPocketCatalog() {
      const catalog = this.pocketCatalog;
      const options = Array.isArray(this.model.options) ? this.model.options : [];
      const sourcePocketIndex = options.findIndex((option) => ['pockets', 'pocket-style'].includes(option.id));
      const catalogValues = Array.isArray(catalog?.values) ? catalog.values : [];
      const exactModelSelectable = Boolean(
        catalog?.selectable === true
        && catalog.sourceOptionId === 'olhausen-design-center-leather-pocket-catalog-2026-09-04'
        && catalog.perValueMappingsComplete === true
        && catalog.policy === 'verified_leather_model_full_official_design_center_catalog'
        && catalogValues.length === 8
        && new Set(catalogValues.map((value) => value.id)).size === 8
        && catalogValues.every((value) => (
          value.eligible === true
          && isString(value.sourceValueId)
          && value.visualMapping?.verified === true
          && value.visualMapping?.transparentBackground === true
          && value.visualMapping?.productPixelsRecolored === false
          && value.visualMapping?.generated === false
          && isString(value.visualMapping?.assetId)
          && isString(value.visualMapping?.assetUrl)
        ))
      );

      if (!exactModelSelectable) {
        if (sourcePocketIndex >= 0) options.splice(sourcePocketIndex, 1);
        this.model.options = options;
        if (this.model.defaults) {
          delete this.model.defaults.pockets;
          delete this.model.defaults['pocket-style'];
        }
        if (this.model.defaultEvidence) {
          delete this.model.defaultEvidence.pockets;
          delete this.model.defaultEvidence['pocket-style'];
        }
        if (this.model.detailSupportAssets?.fixedPocket) delete this.model.detailSupportAssets.fixedPocket;
        this.model.pocketOptionEvidence = {
          selectable: false,
          sourceOptionId: null,
          perValueMappingsComplete: false,
          policy: 'hidden_non_selectable_pocket_construction'
        };
        this.model.product = {
          ...(this.model.product || {}),
          fixedFeatures: (this.model.product?.fixedFeatures || []).filter((feature) => feature.id !== 'pockets')
        };
        if (this.model.compatibilityMatrix?.allowedSourceValueIdsByOption) {
          delete this.model.compatibilityMatrix.allowedSourceValueIdsByOption.pockets;
          delete this.model.compatibilityMatrix.allowedSourceValueIdsByOption['pocket-style'];
        }
        return;
      }

      const values = catalogValues.map((value) => ({
        ...value,
        sourceLabel: value.label,
        visualMapping: { ...value.visualMapping }
      }));
      const pocketOption = {
        id: 'pockets',
        sourceOptionId: catalog.sourceOptionId,
        label: 'Pocket',
        kind: 'visual_reference',
        presentation: 'image_grid',
        viewerEffect: 'detail_image',
        previewPolicy: 'official_detail_reference_only',
        required: true,
        values
      };
      const existingIndex = options.findIndex((option) => ['pockets', 'pocket-style'].includes(option.id));
      if (existingIndex >= 0) options.splice(existingIndex, 1);
      const finishIndex = options.findIndex((option) => option.id === 'finish');
      options.splice(finishIndex >= 0 ? finishIndex + 1 : 0, 0, pocketOption);
      this.model.options = options;
      this.model.defaults = { ...(this.model.defaults || {}), pockets: catalog.defaultValueId };
      this.model.defaultEvidence = { ...(this.model.defaultEvidence || {}), pockets: catalog.defaultEvidence };
      this.model.pocketOptionEvidence = catalog;
      this.model.product = {
        ...(this.model.product || {}),
        fixedFeatures: (this.model.product?.fixedFeatures || []).filter((feature) => feature.id !== 'pockets')
      };
      if (this.model.detailSupportAssets?.fixedPocket) delete this.model.detailSupportAssets.fixedPocket;
      if (this.model.compatibilityMatrix?.allowedSourceValueIdsByOption) {
        this.model.compatibilityMatrix.allowedSourceValueIdsByOption.pockets = values.map((value) => value.sourceValueId);
      }
    }

    applyVisualManifest() {
      if (!this.visualManifest) return;
      const manifest = this.visualManifest;
      const options = Array.isArray(this.model.options) ? this.model.options : [];

      this.model.viewer = manifest.viewer;
      this.model.product = {
        ...(this.model.product || {}),
        fixedFeatures: manifest.fixedFeatures
      };
      this.model.detailSupportAssets = manifest.detailSupportAssets;
      this.model.fixedSightDetail = manifest.detailSupportAssets?.fixedSight;
      this.model.drawerPreviewEvidence = manifest.drawerPreviewEvidence;
      this.model.pocketOptionEvidence = manifest.pocketOptionEvidence;
      const blockedPairs = (this.model.compatibilityRules || []).flatMap((rule) => (
        Array.isArray(rule.blocks)
          ? rule.blocks.map((blocked) => ({
            ruleId: rule.id,
            whenOptionId: rule.when?.optionId,
            whenValueId: rule.when?.valueId,
            blockedOptionId: blocked.optionId,
            blockedValueId: blocked.valueId
          }))
          : []
      ));
      this.model.compatibilityMatrix = {
        mode: 'exact_model_allowlist',
        sourceProductId: this.model.eligibility?.sourceProductId,
        unlistedValuesUnavailable: true,
        allowedSourceValueIdsByOption: Object.fromEntries(
          options.map((option) => [option.id, option.values.map((value) => value.sourceValueId)])
        ),
        blockedPairs,
        pairwiseRuleStatus: blockedPairs.length > 0 ? 'provided_by_model_specific_source' : 'not_provided_by_source',
        pairwiseCompatibilityPassed: blockedPairs.length > 0 ? true : null
      };

      options.forEach((option) => {
        if (option.id === 'finish') {
          option.presentation = 'image_grid';
          option.viewerEffect = 'layer_image';
          option.previewPolicy = 'authorized_product_image';
          option.values.forEach((value) => {
            const mapping = manifest.finishMappings?.[value.id];
            if (!mapping) return;
            const pocketBacking = manifest.pocketBackingMappings?.[value.id];
            value.visualMapping = {
              effect: 'layer_image',
              layerId: 'finish',
              ...mapping,
              ...(pocketBacking ? { pocketBacking } : {}),
              verified: true
            };
          });
        }

        if (option.id === 'cloth') {
          option.viewerEffect = 'aligned_layer_image';
          option.previewPolicy = 'authorized_aligned_source_layer';
          option.values.forEach((value) => {
            const mapping = manifest.clothMappings?.[value.id];
            if (!mapping) return;
            value.visualMapping = {
              effect: 'aligned_layer_image',
              layerId: 'felt',
              ...mapping,
              alignment: 'exact_800x368_source_underlay',
              boundaryOwner: 'finish_render_alpha',
              runtimeMaskApplied: false,
              color: value.color,
              verified: true
            };
          });
        }

        if (option.id === 'sights') {
          option.presentation = 'image_grid';
          option.viewerEffect = 'detail_image';
          option.previewPolicy = 'detail_inset_reference_only';
          option.values.forEach((value) => {
            const mapping = manifest.sightMappings?.[value.id];
            if (!mapping) return;
            value.visualMapping = {
              effect: 'detail_image',
              layerId: 'sights',
              ...mapping,
              ...(value.id === 'black-molded-diamond' ? {
                topPlaneAssetRole: 'illustrative_detail_card_only',
                topPlaneSourceManifest: 'docs/3d-builder-classic-sight-rail-detail.json'
              } : {}),
              verified: true
            };
          });
        }
      });
    }

    validateCatalog() {
      const errors = [];
      const options = Array.isArray(this.model.options) ? this.model.options : [];
      const optionIds = new Set(options.map((option) => option.id));
      const eligibility = this.model.eligibility || {};
      const viewer = this.model.viewer || {};
      const requiredOptionCounts = new Map(Object.entries(this.contract?.optionCounts || {}));
      if (!this.drawerSelectable) requiredOptionCounts.delete('drawer');
      const selectablePocketEvidence = this.model.pocketOptionEvidence?.selectable === true;
      if (selectablePocketEvidence) requiredOptionCounts.set('pockets', 8);
      const expectedFixedFeatures = new Map(
        Object.entries(this.contract?.fixedFeatures || {}).filter(([id]) => id !== 'pockets' || this.fixedPocketVisualEnabled)
      );

      if (!this.contract) errors.push('unsupported_product');

      if (
        this.model.schemaVersion !== '1.1'
        || this.model.catalog?.optionInheritance !== 'none'
        || this.model.catalog?.unmappedOptionsHidden !== true
      ) {
        errors.push('invalid_catalog_policy');
      }

      if (
        eligibility.mode !== 'exact_product'
        || String(eligibility.shopifyProductId) !== this.dataset.productId
        || eligibility.handle !== this.dataset.productHandle
        || eligibility.templateSuffix !== this.dataset.productTemplate
        || eligibility.sourceProductId !== this.contract?.sourceProductId
        || eligibility.validated !== true
      ) {
        errors.push('product_identity_mismatch');
      }

      if (
        viewer.mode !== 'static_finish_felt_image_preview'
        || viewer.interaction?.drag !== false
        || viewer.interaction?.orbit !== false
        || viewer.interaction?.zoom !== false
        || viewer.interaction?.sightHotspot !== false
      ) {
        errors.push('invalid_static_viewer_contract');
      }

      const fixedFeatures = Array.isArray(this.model.product?.fixedFeatures) ? this.model.product.fixedFeatures : [];
      if (fixedFeatures.length !== expectedFixedFeatures.size) {
        errors.push('invalid_fixed_feature_count');
      }

      expectedFixedFeatures.forEach((expectedValue, id) => {
        const feature = fixedFeatures.find((item) => item.id === id);
        if (feature?.value !== expectedValue || feature.status !== 'fixed_model_fact') {
          errors.push(`invalid_fixed_feature:${id}`);
        }
      });

      const pockets = fixedFeatures.find((item) => item.id === 'pockets');
      if (pockets && !this.fixedPocketVisualEnabled) errors.push('unsupported_pocket_ui');

      const fixedPocketDetail = this.model.detailSupportAssets?.fixedPocket;
      if (selectablePocketEvidence && fixedPocketDetail) {
        errors.push('selectable_pocket_has_fixed_detail');
      } else if (this.fixedPocketVisualEnabled && (
        fixedPocketDetail?.construction !== 'leather'
        || fixedPocketDetail?.modelSpecificConstructionVerified !== true
        || fixedPocketDetail?.finishSpecificInstalledAppearanceClaimed !== false
      )) {
        errors.push('invalid_fixed_pocket_detail');
      }

      const pocketOptionEvidence = this.model.pocketOptionEvidence;
      const pocketOptions = options.filter(({ id }) => id === 'pockets' || id === 'pocket-style');
      const validSelectablePocketGate = pocketOptionEvidence?.selectable === true
        && pocketOptionEvidence.sourceOptionId === 'olhausen-design-center-leather-pocket-catalog-2026-09-04'
        && pocketOptionEvidence.perValueMappingsComplete === true
        && pocketOptionEvidence.policy === 'verified_leather_model_full_official_design_center_catalog'
        && pocketOptions.length === 1
        && pocketOptions[0].values?.length === 8
        && !pockets;
      const validHiddenPocketGate = pocketOptionEvidence?.selectable === false
        && pocketOptionEvidence.sourceOptionId === null
        && pocketOptionEvidence.perValueMappingsComplete === false
        && pocketOptionEvidence.policy === 'hidden_non_selectable_pocket_construction'
        && pocketOptions.length === 0
        && !pockets
        && !fixedPocketDetail;
      if (!validSelectablePocketGate && !validHiddenPocketGate) {
        errors.push('invalid_pocket_evidence_gate');
      }

      const drawerOption = options.find(({ id }) => id === 'drawer');
      const drawerEvidence = this.model.drawerPreviewEvidence;
      const drawerMappings = drawerEvidence?.finishMappings;
      const finishValues = options.find(({ id }) => id === 'finish')?.values || [];
      if (!drawerEvidence || !drawerMappings || typeof drawerMappings !== 'object' || Array.isArray(drawerMappings)) {
        errors.push('invalid_drawer_preview_evidence_gate');
      } else if (drawerOption) {
        const completeMapping = drawerEvidence.openPreviewAvailable === true
          && drawerEvidence.perFinishMappingsComplete === true
          && drawerEvidence.mappingMode === 'exact_model_finish_aligned_open_drawer_crossfade';
        const mappedAssetIds = finishValues.map((finish) => drawerMappings[finish.id]?.assetId).filter(isString);
        if (
          drawerEvidence.optionAvailable !== true
          || drawerEvidence.sourceOptionId !== drawerOption.sourceOptionId
          || (completeMapping && (
            Object.keys(drawerMappings).length !== finishValues.length
            || (finishValues.length > 1 && new Set(mappedAssetIds).size !== finishValues.length)
            || finishValues.some((finish) => {
              const mapping = drawerMappings[finish.id];
              return !isString(mapping?.assetId)
                || !isString(mapping?.assetUrl)
                || mapping?.officialModelSpecific !== true
                || mapping?.finishMatched !== true
                || mapping?.alignedToFinishRender !== true
                || mapping?.transparentProductOnly !== true
                || mapping?.containsRoomBackground !== false
                || mapping?.containsPoolBalls !== false
                || mapping?.containsPoolCues !== false;
            })
          ))
          || (!completeMapping && (
            drawerEvidence.openPreviewAvailable !== false
            || drawerEvidence.perFinishMappingsComplete !== false
            || drawerEvidence.mappingMode !== 'quote_only_no_visual'
            || Object.keys(drawerMappings).length !== 0
          ))
        ) {
          errors.push('invalid_drawer_preview_evidence_gate');
        }
      } else if (
        drawerEvidence.optionAvailable !== false
        || drawerEvidence.sourceOptionId !== null
        || drawerEvidence.openPreviewAvailable !== false
        || drawerEvidence.perFinishMappingsComplete !== false
        || drawerEvidence.mappingMode !== 'quote_only_no_visual'
        || Object.keys(drawerMappings).length !== 0
      ) {
        errors.push('invalid_drawer_preview_evidence_gate');
      }

      if (
        drawerEvidence?.referencePreviewAvailable !== false
        || drawerEvidence?.referenceMode !== 'none'
        || drawerEvidence?.referenceAssetId !== null
        || drawerEvidence?.referenceAssetUrl !== null
        || drawerEvidence?.referenceOfficialModelSpecific !== false
        || drawerEvidence?.referenceAlignedToFinishRender !== false
        || drawerEvidence?.referenceFinishMatched !== false
        || drawerEvidence?.referencePresentationClean !== false
        || drawerEvidence?.referenceContainsRoomBackground !== null
        || drawerEvidence?.referenceContainsPoolBalls !== null
        || drawerEvidence?.referenceContainsPoolCues !== null
        || drawerEvidence?.referencePicturedFinish !== null
      ) {
        errors.push('invalid_drawer_reference_evidence_gate');
      }

      if (optionIds.size !== requiredOptionCounts.size || [...requiredOptionCounts.keys()].some((id) => !optionIds.has(id))) {
        errors.push('product_option_set_mismatch');
      }

      const compatibilityMatrix = this.model.compatibilityMatrix || {};
      const expectedCompatibilityRuleCount = this.contract?.compatibilityRuleCount || 0;
      if (
        compatibilityMatrix.mode !== 'exact_model_allowlist'
        || compatibilityMatrix.sourceProductId !== eligibility.sourceProductId
        || compatibilityMatrix.unlistedValuesUnavailable !== true
        || !Array.isArray(compatibilityMatrix.blockedPairs)
        || compatibilityMatrix.blockedPairs.length !== expectedCompatibilityRuleCount
        || compatibilityMatrix.pairwiseRuleStatus !== (expectedCompatibilityRuleCount > 0 ? 'provided_by_model_specific_source' : 'not_provided_by_source')
        || compatibilityMatrix.pairwiseCompatibilityPassed !== (expectedCompatibilityRuleCount > 0 ? true : null)
      ) {
        errors.push('invalid_compatibility_matrix');
      }

      const compatibilityRules = Array.isArray(this.model.compatibilityRules) ? this.model.compatibilityRules : [];
      if (
        compatibilityRules.length !== expectedCompatibilityRuleCount
        || compatibilityRules.some((rule) => (
          !isString(rule.id)
          || !isString(rule.source)
          || !isString(rule.reason)
          || !isString(rule.when?.optionId)
          || !isString(rule.when?.valueId)
          || !Array.isArray(rule.blocks)
          || rule.blocks.length !== 1
          || !isString(rule.blocks[0]?.optionId)
          || !isString(rule.blocks[0]?.valueId)
        ))
      ) {
        errors.push('invalid_compatibility_rules');
      }

      options.forEach((option) => {
        const expectedCount = requiredOptionCounts.get(option.id);
        if (!isString(option.sourceOptionId) || !expectedCount || option.values?.length !== expectedCount) {
          errors.push(`invalid_option:${option.id || 'unknown'}`);
          return;
        }

        const valueIds = new Set();
        option.values.forEach((value) => {
          if (!isString(value.id) || !isString(value.sourceValueId) || value.eligible !== true || valueIds.has(value.id)) {
            errors.push(`invalid_value:${option.id}:${value.id || 'unknown'}`);
          }
          valueIds.add(value.id);

          if (
            option.id === 'finish'
            && (
              option.previewPolicy !== 'authorized_product_image'
              || value.visualMapping?.effect !== 'layer_image'
              || value.visualMapping?.verified !== true
              || !isString(value.visualMapping?.assetUrl)
            )
          ) {
            errors.push(`invalid_finish_mapping:${value.id}`);
          }

          if (
            option.id === 'finish'
            && this.contract?.pocketBackingRequired === true
            && (
              !isString(value.visualMapping?.pocketBacking?.assetId)
              || !isString(value.visualMapping?.pocketBacking?.assetUrl)
              || value.visualMapping?.pocketBacking?.method !== 'source_derived_finish_matched_fixed_pocket_underlay'
            )
          ) {
            errors.push(`invalid_pocket_backing_mapping:${value.id}`);
          }

          if (
            option.id === 'finish'
            && this.contract?.pocketBackingRequired !== true
            && value.visualMapping?.pocketBacking
          ) {
            errors.push(`unexpected_pocket_backing_mapping:${value.id}`);
          }

          if (
            option.id === 'cloth'
            && (
              option.previewPolicy !== 'authorized_aligned_source_layer'
              || option.viewerEffect !== 'aligned_layer_image'
              || !isHexColor(value.color)
              || value.visualMapping?.effect !== 'aligned_layer_image'
              || value.visualMapping?.layerId !== 'felt'
              || value.visualMapping?.color !== value.color
              || !isString(value.visualMapping?.assetUrl)
              || !isString(value.visualMapping?.assetId)
              || !isString(value.visualMapping?.sourceImageId)
              || value.visualMapping?.alignment !== 'exact_800x368_source_underlay'
              || value.visualMapping?.boundaryOwner !== 'finish_render_alpha'
              || value.visualMapping?.runtimeMaskApplied !== false
              || value.visualMapping?.verified !== true
            )
          ) {
            errors.push(`invalid_cloth_layer:${value.id}`);
          }

          if (
            option.id === 'sights'
            && (
              option.previewPolicy !== 'detail_inset_reference_only'
              || value.visualMapping?.effect !== 'detail_image'
              || value.visualMapping?.verified !== true
              || !isString(value.visualMapping?.assetUrl)
            )
          ) {
            errors.push(`invalid_sight_reference:${value.id}`);
          }

          if (
            option.id === 'pockets'
            && (
              option.previewPolicy !== 'official_detail_reference_only'
              || value.visualMapping?.effect !== 'detail_image'
              || value.visualMapping?.layerId !== 'pockets'
              || value.visualMapping?.verified !== true
              || value.visualMapping?.transparentBackground !== true
              || value.visualMapping?.productPixelsRecolored !== false
              || value.visualMapping?.generated !== false
              || !isString(value.visualMapping?.assetId)
              || !isString(value.visualMapping?.assetUrl)
              || !isString(value.visualMapping?.sourceUrl)
            )
          ) {
            errors.push(`invalid_pocket_reference:${value.id}`);
          }

        });

        if (!valueIds.has(this.model.defaults?.[option.id])) {
          errors.push(`invalid_default:${option.id}`);
        }

        const allowedSourceValueIds = compatibilityMatrix.allowedSourceValueIdsByOption?.[option.id];
        if (
          !Array.isArray(allowedSourceValueIds)
          || allowedSourceValueIds.length !== valueIds.size
          || option.values.some((value) => !allowedSourceValueIds.includes(value.sourceValueId))
          || allowedSourceValueIds.some((sourceValueId) => !option.values.some((value) => value.sourceValueId === sourceValueId))
        ) {
          errors.push(`invalid_option_allowlist:${option.id}`);
        }
      });

      if (this.model.verification?.quoteBridge !== 'unknown') {
        errors.push('invalid_prototype_boundary');
      }

      const support = this.model.detailSupportAssets || {};
      const pocketDetails = support.pocketDetails;
      if (
        !isString(support.feltTexture?.assetId)
        || !isString(support.feltTexture?.assetUrl)
        || support.feltTexture?.role !== 'purpose_built_neutral_billiard_cloth_texture'
        || support.feltTexture?.runtimeMapping !== 'deterministic_official_render_bed_sample_lab_normalization'
        || support.feltTexture?.generated !== true
        || support.feltTexture?.width !== 1024
        || support.feltTexture?.height !== 1024
        || !isString(support.railTop?.assetId)
        || !isString(support.railTop?.assetUrl)
        || support.railTop?.role !== 'purpose_built_straight_down_neutral_rail_top_texture'
        || support.railTop?.runtimeMapping !== 'deterministic_official_top_rail_sample_lab_normalization'
        || support.railTop?.generated !== true
        || support.railTop?.width !== 1254
        || support.railTop?.height !== 1254
        || !pocketDetails
        || typeof pocketDetails !== 'object'
        || Array.isArray(pocketDetails)
        || (this.contract?.pocketDetailRequired === true && Object.keys(pocketDetails).length !== finishValues.length)
        || Object.entries(pocketDetails).some(([finishId, detail]) => (
          !finishValues.some((finish) => finish.id === finishId)
          || !isString(detail?.assetId)
          || !isString(detail?.assetUrl)
          || detail?.sourceProductId !== this.model.eligibility?.sourceProductId
          || detail?.officialModelSpecific !== true
          || detail?.finishMatched !== true
          || detail?.role !== 'exact_official_fixed_pocket_direct_corner_crop'
          || detail?.method !== 'exact_native_source_pixel_crop_no_resize_no_warp_no_generation'
          || detail?.generated !== false
          || detail?.containsPoolBalls !== false
          || detail?.containsPoolCues !== false
          || !Number.isInteger(detail?.width)
          || !Number.isInteger(detail?.height)
          || detail.width < 180
          || detail.height < 180
        ))
      ) {
        errors.push('invalid_detail_support_assets');
      }

      const sightOption = options.find(({ id }) => id === 'sights');
      const fixedSight = support.fixedSight;
      if (this.contract?.fixedSight) {
        if (
          sightOption
          || fixedSight?.id !== this.contract.fixedSight.id
          || fixedSight?.label !== this.contract.fixedSight.label
          || !isString(fixedSight?.assetId)
          || !isString(fixedSight?.assetUrl)
          || fixedSight?.sourceProductId !== eligibility.sourceProductId
          || fixedSight?.officialModelSpecific !== true
          || fixedSight?.role !== 'exact_official_fixed_sight_reference'
          || fixedSight?.method !== 'exact_source_pixel_crop_with_measured_circular_alpha_mask'
          || fixedSight?.generated !== false
          || fixedSight?.recolored !== false
          || fixedSight?.warped !== false
        ) {
          errors.push('invalid_fixed_sight_evidence');
        }
      } else if (fixedSight) {
        errors.push('unexpected_fixed_sight_evidence');
      }

      const sightDetailReady = SIGHT_DETAIL_READY_HANDLES.has(this.dataset.productHandle);
      const sightDetailBlocked = Object.hasOwn(SIGHT_DETAIL_FAIL_CLOSED_REASONS, this.dataset.productHandle);
      if (sightDetailReady === sightDetailBlocked) errors.push('invalid_sight_detail_evidence_gate');

      return errors;
    }

    restoreState() {
      try {
        const stored = JSON.parse(sessionStorage.getItem(this.storageKey()));
        if (!stored || typeof stored !== 'object') return;

        this.model.options?.forEach((option) => {
          if (option.values.some((value) => value.id === stored[option.id] && value.eligible === true)) {
            this.state[option.id] = stored[option.id];
          }
        });
      } catch (error) {
        this.dataset.storageUnavailable = 'true';
      }
    }

    storageKey() {
      return `badlands-pool-table-visualizer:${this.dataset.productId}:${this.model.catalogVersion}`;
    }

    bindActions() {
      this.useButton?.addEventListener('click', () => this.commitConfiguration());
    }

    preloadVisualImages() {
      this.model.options
        ?.filter((option) => ['finish', 'pockets', 'cloth', 'sights'].includes(option.id))
        .flatMap((option) => option.values || [])
        .forEach((value) => {
          [value.visualMapping?.assetUrl, value.visualMapping?.pocketBacking?.assetUrl]
            .filter(Boolean)
            .forEach((url) => void this.loadVisualImage(url));
        });
      Object.values(this.model.detailSupportAssets || {})
        .map((asset) => asset?.assetUrl)
        .filter(Boolean)
        .forEach((url) => void this.loadVisualImage(url));
      Object.values(this.model.detailSupportAssets?.pocketDetails || {})
        .map((asset) => asset?.assetUrl)
        .filter(Boolean)
        .forEach((url) => void this.loadVisualImage(url));
      Object.values(this.model.drawerPreviewEvidence?.finishMappings || {})
        .map((mapping) => mapping?.assetUrl)
        .filter(Boolean)
        .forEach((url) => void this.loadVisualImage(url));
    }

    loadVisualImage(url) {
      if (this.visualImageCache.has(url)) return this.visualImageCache.get(url);
      const promise = new Promise((resolve, reject) => {
        const image = new Image();
        image.addEventListener('load', () => resolve(image), { once: true });
        image.addEventListener('error', () => reject(new Error(`Unable to load pool-table detail asset: ${url}`)), { once: true });
        image.src = url;
      });
      this.visualImageCache.set(url, promise);
      return promise;
    }

    alphaBounds(image, cacheKey) {
      if (this.imageAlphaBoundsCache.has(cacheKey)) return this.imageAlphaBoundsCache.get(cacheKey);
      const canvas = document.createElement('canvas');
      canvas.width = image.naturalWidth;
      canvas.height = image.naturalHeight;
      const context = canvas.getContext('2d', { willReadFrequently: true });
      context.drawImage(image, 0, 0);
      const pixels = context.getImageData(0, 0, canvas.width, canvas.height).data;
      let minX = canvas.width;
      let minY = canvas.height;
      let maxX = -1;
      let maxY = -1;
      for (let y = 0; y < canvas.height; y += 1) {
        for (let x = 0; x < canvas.width; x += 1) {
          if (pixels[(y * canvas.width + x) * 4 + 3] < 24) continue;
          minX = Math.min(minX, x);
          minY = Math.min(minY, y);
          maxX = Math.max(maxX, x);
          maxY = Math.max(maxY, y);
        }
      }
      const bounds = maxX >= minX
        ? { x: minX, y: minY, width: maxX - minX + 1, height: maxY - minY + 1 }
        : { x: 0, y: 0, width: canvas.width, height: canvas.height };
      this.imageAlphaBoundsCache.set(cacheKey, bounds);
      return bounds;
    }

    drawSquareCrop(canvas, image, crop, backingImage = null, preserveNativeResolution = false) {
      if (preserveNativeResolution && (canvas.width !== crop.width || canvas.height !== crop.height)) {
        canvas.width = crop.width;
        canvas.height = crop.height;
      }
      const context = canvas.getContext('2d');
      context.clearRect(0, 0, canvas.width, canvas.height);
      context.imageSmoothingEnabled = true;
      context.imageSmoothingQuality = 'high';
      if (backingImage) {
        context.drawImage(backingImage, crop.x, crop.y, crop.width, crop.height, 0, 0, canvas.width, canvas.height);
      }
      context.drawImage(image, crop.x, crop.y, crop.width, crop.height, 0, 0, canvas.width, canvas.height);
    }

    drawContainedImage(canvas, image) {
      if (canvas.width !== 384 || canvas.height !== 384) {
        canvas.width = 384;
        canvas.height = 384;
      }
      const context = canvas.getContext('2d');
      context.clearRect(0, 0, canvas.width, canvas.height);
      context.imageSmoothingEnabled = true;
      context.imageSmoothingQuality = 'high';
      const scale = Math.min(canvas.width / image.naturalWidth, canvas.height / image.naturalHeight);
      const width = Math.round(image.naturalWidth * scale);
      const height = Math.round(image.naturalHeight * scale);
      context.drawImage(image, Math.round((canvas.width - width) / 2), Math.round((canvas.height - height) / 2), width, height);
    }

    drawInstalledPocketDetail(canvas, finishImage, clothImage, feltClipImage, feltTextureImage, feltTarget, focalCrop, pocketImage, pocketAssetUrl, installation) {
      if (!focalCrop || !installation?.target) throw new Error('Missing source-reviewed pocket installation geometry');
      if (canvas.width !== 384 || canvas.height !== 384) {
        canvas.width = 384;
        canvas.height = 384;
      }
      const context = canvas.getContext('2d');
      const crop = this.expandedPocketCrop(finishImage, focalCrop);
      context.clearRect(0, 0, canvas.width, canvas.height);
      context.imageSmoothingEnabled = true;
      context.imageSmoothingQuality = 'high';
      const clothLayer = document.createElement('canvas');
      clothLayer.width = canvas.width;
      clothLayer.height = canvas.height;
      const clothContext = clothLayer.getContext('2d');
      clothContext.imageSmoothingEnabled = true;
      clothContext.imageSmoothingQuality = 'high';
      clothContext.drawImage(clothImage, crop.x, crop.y, crop.width, crop.height, 0, 0, canvas.width, canvas.height);
      if (feltClipImage) {
        clothContext.globalCompositeOperation = 'destination-in';
        clothContext.drawImage(feltClipImage, crop.x, crop.y, crop.width, crop.height, 0, 0, canvas.width, canvas.height);
        clothContext.globalCompositeOperation = 'source-over';
      }
      context.drawImage(clothLayer, 0, 0);
      context.drawImage(finishImage, crop.x, crop.y, crop.width, crop.height, 0, 0, canvas.width, canvas.height);

      const bounds = this.alphaBounds(pocketImage, pocketAssetUrl);
      const scaleX = canvas.width / crop.width;
      const scaleY = canvas.height / crop.height;
      const target = {
        x: installation.target.x * scaleX,
        y: installation.target.y * scaleY,
        width: installation.target.width * scaleX,
        height: installation.target.height * scaleY
      };
      const pocketLayer = document.createElement('canvas');
      pocketLayer.width = canvas.width;
      pocketLayer.height = canvas.height;
      const pocketContext = pocketLayer.getContext('2d');
      pocketContext.imageSmoothingEnabled = true;
      pocketContext.imageSmoothingQuality = 'high';
      pocketContext.translate(target.x + target.width / 2, target.y + target.height / 2);
      pocketContext.transform(1, installation.skewY || 0, installation.skewX || 0, 1, 0, 0);
      pocketContext.rotate((installation.rotationDegrees || 0) * Math.PI / 180);
      pocketContext.drawImage(
        pocketImage,
        bounds.x,
        bounds.y,
        bounds.width,
        bounds.height,
        -target.width / 2,
        -target.height / 2,
        target.width,
        target.height
      );

      const pocketPixels = pocketContext.getImageData(0, 0, canvas.width, canvas.height);
      const mask = document.createElement('canvas');
      mask.width = canvas.width;
      mask.height = canvas.height;
      const maskContext = mask.getContext('2d');
      const maskPixels = maskContext.createImageData(canvas.width, canvas.height);
      const padding = Math.max(0, Math.round((installation.maskPadding || 0) * scaleX));
      let maskPixelCount = 0;
      for (let y = 0; y < canvas.height; y += 1) {
        let left = canvas.width;
        let right = -1;
        for (let x = 0; x < canvas.width; x += 1) {
          if (pocketPixels.data[(y * canvas.width + x) * 4 + 3] < POCKET_MASK_ALPHA_THRESHOLD) continue;
          left = Math.min(left, x);
          right = Math.max(right, x);
        }
        if (right < left) continue;
        left = Math.max(0, left - padding);
        right = Math.min(canvas.width - 1, right + padding);
        for (let x = left; x <= right; x += 1) {
          maskPixels.data[(y * canvas.width + x) * 4 + 3] = 255;
          maskPixelCount += 1;
        }
      }
      if (maskPixelCount < 500) throw new Error('Pocket installation mask is too small');
      maskContext.putImageData(maskPixels, 0, 0);

      const sourcePocketConcealmentPixelCount = 0;

      const feltBacking = document.createElement('canvas');
      feltBacking.width = canvas.width;
      feltBacking.height = canvas.height;
      const interiorContext = feltBacking.getContext('2d');
      interiorContext.fillStyle = '#121212';
      interiorContext.fillRect(0, 0, feltBacking.width, feltBacking.height);
      const maskedBacking = document.createElement('canvas');
      maskedBacking.width = canvas.width;
      maskedBacking.height = canvas.height;
      const maskedBackingContext = maskedBacking.getContext('2d');
      maskedBackingContext.drawImage(feltBacking, 0, 0);
      maskedBackingContext.globalCompositeOperation = 'destination-in';
      maskedBackingContext.drawImage(mask, 0, 0);
      maskedBackingContext.globalCompositeOperation = 'source-over';

      context.save();
      context.globalCompositeOperation = 'destination-out';
      context.drawImage(mask, 0, 0);
      context.restore();
      context.drawImage(maskedBacking, 0, 0);
      context.drawImage(pocketLayer, 0, 0);
      return {
        crop,
        target,
        maskPixelCount,
        sourcePocketConcealmentPixelCount,
        feltBackingDeltaE: null
      };
    }

    expandedPocketCrop(image, focalCrop) {
      const size = Math.min(POCKET_DETAIL_SOURCE_SIZE, image.naturalWidth, image.naturalHeight);
      const centerX = focalCrop.x + focalCrop.width / 2;
      const centerY = focalCrop.y + focalCrop.height / 2;
      return {
        x: Math.round(clamp(centerX - size / 2, 0, image.naturalWidth - size)),
        y: Math.round(clamp(centerY - size / 2, 0, image.naturalHeight - size)),
        width: size,
        height: size
      };
    }

    imagePixels(image, cacheKey) {
      if (this.imageDataCache.has(cacheKey)) return this.imageDataCache.get(cacheKey);
      const canvas = document.createElement('canvas');
      canvas.width = image.naturalWidth;
      canvas.height = image.naturalHeight;
      const context = canvas.getContext('2d', { willReadFrequently: true });
      context.drawImage(image, 0, 0);
      const result = { width: canvas.width, height: canvas.height, pixels: context.getImageData(0, 0, canvas.width, canvas.height).data };
      this.imageDataCache.set(cacheKey, result);
      return result;
    }

    robustLab(samples) {
      if (samples.length < 32) throw new Error(`Insufficient representative color sample: ${samples.length}`);
      const sorted = [...samples].sort((left, right) => left.l - right.l);
      const trimCount = Math.floor(sorted.length * ROBUST_LUMINANCE_TRIM);
      const retained = sorted.slice(trimCount, sorted.length - trimCount);
      return {
        lab: {
          l: median(retained.map(({ l }) => l)),
          a: median(retained.map(({ a }) => a)),
          b: median(retained.map(({ b }) => b))
        },
        rawCount: samples.length,
        retainedCount: retained.length
      };
    }

    enclosedBedIndices(finishImage, cacheKey) {
      if (this.enclosedBedIndexCache.has(cacheKey)) return this.enclosedBedIndexCache.get(cacheKey);
      const { width, height, pixels } = this.imagePixels(finishImage, cacheKey);
      const visited = new Uint8Array(width * height);
      const queue = new Int32Array(width * height);
      let largest = [];
      for (let start = 0; start < visited.length; start += 1) {
        if (visited[start] || pixels[start * 4 + 3] !== 0) continue;
        let head = 0;
        let tail = 0;
        let touchesEdge = false;
        const component = [];
        queue[tail++] = start;
        visited[start] = 1;
        while (head < tail) {
          const pixelIndex = queue[head++];
          component.push(pixelIndex);
          const x = pixelIndex % width;
          const y = Math.floor(pixelIndex / width);
          if (x === 0 || y === 0 || x === width - 1 || y === height - 1) touchesEdge = true;
          const neighbors = [pixelIndex - 1, pixelIndex + 1, pixelIndex - width, pixelIndex + width];
          for (const neighbor of neighbors) {
            if (neighbor < 0 || neighbor >= visited.length || visited[neighbor]) continue;
            const neighborX = neighbor % width;
            const neighborY = Math.floor(neighbor / width);
            if (Math.abs(neighborX - x) + Math.abs(neighborY - y) !== 1) continue;
            if (pixels[neighbor * 4 + 3] !== 0) continue;
            visited[neighbor] = 1;
            queue[tail++] = neighbor;
          }
        }
        if (!touchesEdge && component.length > largest.length) largest = component;
      }
      if (largest.length < 10000) throw new Error(`Unable to derive official enclosed bed sample: ${cacheKey}`);
      const indices = Int32Array.from(largest);
      this.enclosedBedIndexCache.set(cacheKey, indices);
      return indices;
    }

    feltSourceTarget(finishImage, clothImage, finishKey, clothKey) {
      const cacheKey = `felt:${finishKey}:${clothKey}`;
      if (this.detailColorTargetCache.has(cacheKey)) return this.detailColorTargetCache.get(cacheKey);
      const bedIndices = this.enclosedBedIndices(finishImage, finishKey);
      const cloth = this.imagePixels(clothImage, clothKey);
      const samples = [];
      for (const pixelIndex of bedIndices) {
        const index = pixelIndex * 4;
        if (cloth.pixels[index + 3] < 250) continue;
        samples.push(rgbToLab(cloth.pixels[index], cloth.pixels[index + 1], cloth.pixels[index + 2]));
      }
      const result = { ...this.robustLab(samples), method: 'official-cloth-within-finish-derived-enclosed-bed' };
      this.detailColorTargetCache.set(cacheKey, result);
      return result;
    }

    finishRailSourceTarget(finishImage, finishKey) {
      const cacheKey = `rail:${finishKey}`;
      if (this.detailColorTargetCache.has(cacheKey)) return this.detailColorTargetCache.get(cacheKey);
      const source = this.imagePixels(finishImage, finishKey);
      if (this.contract.finishSampleMode === 'robust-visible-finish') {
        const samples = [];
        for (let pixelIndex = 0; pixelIndex < source.width * source.height; pixelIndex += 1) {
          const index = pixelIndex * 4;
          if (source.pixels[index + 3] < 220) continue;
          const lab = rgbToLab(source.pixels[index], source.pixels[index + 1], source.pixels[index + 2]);
          if (lab.l <= 2) continue;
          samples.push(lab);
        }
        const result = { ...this.robustLab(samples), method: 'exact-selected-finish-visible-pixels-with-alpha-and-luminance-extremes-excluded' };
        this.detailColorTargetCache.set(cacheKey, result);
        return result;
      }
      const directionX = Math.cos(RAIL_TOP_SAMPLE.angleRadians);
      const directionY = Math.sin(RAIL_TOP_SAMPLE.angleRadians);
      const normalX = -directionY;
      const normalY = directionX;
      const samples = [];
      for (let y = 0; y < source.height; y += 1) {
        for (let x = RAIL_TOP_SAMPLE.minX; x <= RAIL_TOP_SAMPLE.maxX; x += 1) {
          const normalDistance = Math.abs((x - RAIL_TOP_SAMPLE.anchorX) * normalX + (y - RAIL_TOP_SAMPLE.anchorY) * normalY);
          if (normalDistance > RAIL_TOP_SAMPLE.halfNormalWidth) continue;
          if (RAIL_TOP_SAMPLE.sightCenters.some((center) => Math.hypot(x - center.x, y - center.y) <= RAIL_TOP_SAMPLE.excludedSightRadius)) continue;
          const index = (y * source.width + x) * 4;
          if (source.pixels[index + 3] < 220) continue;
          samples.push(rgbToLab(source.pixels[index], source.pixels[index + 1], source.pixels[index + 2]));
        }
      }
      const result = { ...this.robustLab(samples), method: 'official-pocket-free-top-rail-band-with-sights-and-luminance-extremes-excluded' };
      this.detailColorTargetCache.set(cacheKey, result);
      return result;
    }

    textureLuminanceProfile(canvas, image, cacheKey) {
      const profileKey = `${cacheKey}:${canvas.width}x${canvas.height}`;
      if (this.textureLuminanceProfileCache.has(profileKey)) return this.textureLuminanceProfileCache.get(profileKey);
      const context = canvas.getContext('2d', { willReadFrequently: true });
      context.clearRect(0, 0, canvas.width, canvas.height);
      context.imageSmoothingEnabled = true;
      context.imageSmoothingQuality = 'high';
      context.drawImage(image, 0, 0, image.naturalWidth, image.naturalHeight, 0, 0, canvas.width, canvas.height);
      const source = context.getImageData(0, 0, canvas.width, canvas.height);
      const luminance = new Float32Array(canvas.width * canvas.height);
      const values = [];
      for (let pixelIndex = 0; pixelIndex < luminance.length; pixelIndex += 1) {
        const index = pixelIndex * 4;
        const l = rgbToLab(source.data[index], source.data[index + 1], source.data[index + 2]).l;
        luminance[pixelIndex] = l;
        values.push(l);
      }
      const result = { luminance, medianL: median(values) };
      this.textureLuminanceProfileCache.set(profileKey, result);
      return result;
    }

    paintSourceMatchedTexture(canvas, image, targetLab, cacheKey) {
      const context = canvas.getContext('2d', { willReadFrequently: true });
      const profile = this.textureLuminanceProfile(canvas, image, cacheKey);
      const output = context.createImageData(canvas.width, canvas.height);
      const representativeSamples = [];
      for (let pixelIndex = 0; pixelIndex < profile.luminance.length; pixelIndex += 1) {
        const rgb = labToRgb({
          l: clamp(targetLab.l + profile.luminance[pixelIndex] - profile.medianL, 0, 100),
          a: targetLab.a,
          b: targetLab.b
        });
        const index = pixelIndex * 4;
        output.data[index] = rgb.red;
        output.data[index + 1] = rgb.green;
        output.data[index + 2] = rgb.blue;
        output.data[index + 3] = 255;
        if (pixelIndex % 4 === 0) representativeSamples.push(rgbToLab(rgb.red, rgb.green, rgb.blue));
      }
      context.putImageData(output, 0, 0);
      const representative = this.robustLab(representativeSamples).lab;
      const deltaE = deltaE76(targetLab, representative);
      if (deltaE > DETAIL_COLOR_DELTA_E_MAX) throw new Error(`Detail texture color calibration exceeded Delta E threshold: ${deltaE.toFixed(4)}`);
      return { representative, deltaE };
    }

    sightDetailEvidence() {
      const handle = this.dataset.productHandle;
      if (SIGHT_DETAIL_READY_HANDLES.has(handle)) {
        return {
          available: true,
          method: 'purpose_built_straight_down_support_lab_normalized_to_selected_finish'
        };
      }
      return {
        available: false,
        reason: SIGHT_DETAIL_FAIL_CLOSED_REASONS[handle] || 'missing_exact_selected_finish_sight_background_evidence'
      };
    }

    clearSightDetail(reason) {
      const context = this.sightDetail.getContext('2d');
      context.clearRect(0, 0, this.sightDetail.width, this.sightDetail.height);
      this.sightDetail.removeAttribute('data-finish-background-asset-id');
      this.sightDetail.setAttribute('aria-label', `Sight detail unavailable: ${reason.replaceAll('_', ' ')}. Use the exact official sight reference in the selection control.`);
      this.detailSightCaption.textContent = '';
      this.sightCard.hidden = true;
      for (const key of Object.keys(this.sightCard.dataset)) {
        if (key !== 'classicSightCard') delete this.sightCard.dataset[key];
      }
      this.sightCard.dataset.renderStatus = 'unavailable';
      this.sightCard.dataset.unavailableReason = reason;
    }

    async renderDetailCards(finish, cloth, sights) {
      if (!this.feltDetail || !this.sightDetail || (this.pocketVisualEnabled && !this.pocketDetail)) return;
      const renderToken = ++this.detailRenderToken;
      [this.feltCard, this.sightCard, ...(this.pocketVisualEnabled ? [this.pocketCard] : [])].forEach((card) => {
        if (card) card.dataset.renderStatus = 'loading';
      });

      const feltTexture = this.model.detailSupportAssets?.feltTexture;
      const railTop = this.model.detailSupportAssets?.railTop;
      const selectedPocket = this.selectablePocketVisualEnabled ? this.selectedValue('pockets') : null;
      const pocketDetailSupport = selectedPocket?.visualMapping;
      const fixedPocketDetail = this.fixedPocketVisualEnabled ? this.fixedPocketDetail : null;
      const sightAssetUrl = sights.visualMapping.assetUrl;
      const sightEvidence = this.sightDetailEvidence();
      try {
        const [finishImage, clothImage, feltClipImage, feltTextureImage, railTextureImage, sightImage, pocketDetailImage, fixedPocketImage] = await Promise.all([
          this.loadVisualImage(finish.visualMapping.assetUrl),
          this.loadVisualImage(cloth.visualMapping.assetUrl),
          finish.visualMapping.feltClipAssetUrl ? this.loadVisualImage(finish.visualMapping.feltClipAssetUrl) : Promise.resolve(null),
          this.loadVisualImage(feltTexture.assetUrl),
          this.loadVisualImage(railTop.assetUrl),
          sightEvidence.available ? this.loadVisualImage(sightAssetUrl) : Promise.resolve(null),
          pocketDetailSupport ? this.loadVisualImage(pocketDetailSupport.assetUrl) : Promise.resolve(null),
          fixedPocketDetail ? this.loadVisualImage(fixedPocketDetail.assetUrl) : Promise.resolve(null)
        ]);
        if (renderToken !== this.detailRenderToken) return;
        const feltTarget = this.feltSourceTarget(
          finishImage,
          clothImage,
          finish.visualMapping.assetUrl,
          cloth.visualMapping.assetUrl
        );

        if (this.fixedPocketVisualEnabled && fixedPocketImage) {
          this.drawContainedImage(this.pocketDetail, fixedPocketImage);
          this.pocketDetail.setAttribute('aria-label', `${this.model.product.title} fixed leather pocket construction reference: official Olhausen ${fixedPocketDetail.label}. The selected finish render remains the source for installed pocket appearance.`);
          this.pocketCaption.textContent = fixedPocketDetail.label;
          if (this.pocketFixedNote) this.pocketFixedNote.hidden = true;
          Object.assign(this.pocketCard.dataset, {
            renderStatus: 'ready',
            selectable: 'false',
            construction: fixedPocketDetail.construction,
            sourceAssetId: fixedPocketDetail.assetId,
            sourceMode: 'official-olhausen-design-center-fixed-construction-reference',
            modelSpecificConstructionVerified: 'true',
            finishSpecificInstalledAppearanceClaimed: 'false'
          });
          this.pocketCard.hidden = false;
        } else if (this.selectablePocketVisualEnabled) {
          if (!selectedPocket || !pocketDetailSupport || !pocketDetailImage) throw new Error('Missing selected pocket detail');
          const installation = POCKET_INSTALLATIONS[this.dataset.productHandle];
          const pocketRender = this.drawInstalledPocketDetail(
            this.pocketDetail,
            finishImage,
            clothImage,
            feltClipImage,
            feltTextureImage,
            feltTarget,
            this.contract?.pocketCrop,
            pocketDetailImage,
            pocketDetailSupport.assetUrl,
            installation
          );
          const pocketFeltDescription = `${cloth.label} felt on the table and a neutral dark pocket interior`;
          this.pocketDetail.setAttribute('aria-label', `${finish.label} exact ${this.model.product.title} corner with ${selectedPocket.label} installed in the source-reviewed corner position and ${pocketFeltDescription}. Finish, Pocket, and Felt selections are current. The main product image remains unchanged because complete exact six-pocket placement geometry is unavailable.`);
          this.pocketCaption.textContent = selectedPocket.label;
          if (this.pocketFixedNote) this.pocketFixedNote.hidden = true;
          Object.assign(this.pocketCard.dataset, {
            renderStatus: 'ready',
            pocketId: selectedPocket.id,
            finishId: finish.id,
            clothId: cloth.id,
            selectable: 'true',
            sourceAssetId: pocketDetailSupport.assetId,
            sourceMode: 'exact-selected-finish-and-felt-corner-with-installed-official-pocket',
            compositionMode: 'pocket-only-installed-corner-composite',
            pocketOnlyComposited: 'true',
            wholeProductOverlay: 'false',
            separateReferenceInset: 'false',
            whiteBackground: 'false',
            fullProductPlacementClaimed: 'false',
            mainProductPocketSynchronized: 'false',
            cornerCrop: `${pocketRender.crop.x},${pocketRender.crop.y},${pocketRender.crop.width},${pocketRender.crop.height}`,
            installationTarget: `${installation.target.x},${installation.target.y},${installation.target.width},${installation.target.height}`,
            installationSkewX: String(installation.skewX || 0),
            installationSkewY: String(installation.skewY || 0),
            installationRotationDegrees: String(installation.rotationDegrees || 0),
            installationMask: 'transformed-official-pocket-alpha-row-hull-no-exterior-padding',
            installationMaskAlphaThreshold: String(POCKET_MASK_ALPHA_THRESHOLD),
            installationMaskPadding: String(installation.maskPadding || 0),
            installationMaskPixelCount: String(pocketRender.maskPixelCount),
            sourcePocketConcealment: installation.sourcePocketConcealment?.method || 'none',
            sourcePocketConcealmentPixelCount: String(pocketRender.sourcePocketConcealmentPixelCount || 0),
            feltBackingMode: 'neutral-dark-pocket-interior',
            feltBackingDeltaE76: pocketRender.feltBackingDeltaE?.toFixed(4) ?? '',
            generated: String(pocketDetailSupport.generated === true),
            recolored: String(pocketDetailSupport.productPixelsRecolored === true)
          });
          this.pocketCard.hidden = false;
        }

        const feltCalibration = this.paintSourceMatchedTexture(
          this.feltDetail,
          feltTextureImage,
          feltTarget.lab,
          feltTexture.assetUrl
        );
        const feltTargetHex = rgbHex(labToRgb(feltTarget.lab));
        this.feltDetail.setAttribute(
          'aria-label',
          this.dataset.productHandle === 'classic'
            ? `${cloth.label} sharp billiard-cloth material close-up calibrated to the robust representative color sampled from the exact official Classic cloth layer within the visible bed. Color difference is Delta E ${feltCalibration.deltaE.toFixed(2)}; no enlarged source crop, rail, or table geometry is shown.`
            : `${cloth.label} sharp billiard-cloth material close-up calibrated to the robust representative color sampled from the exact official cloth layer within the visible ${this.model.product.title} bed. Color difference is Delta E ${feltCalibration.deltaE.toFixed(2)}; no enlarged source crop, rail, or table geometry is shown.`
        );
        this.detailFeltCaption.textContent = cloth.label;
        Object.assign(this.feltCard.dataset, {
          renderStatus: 'ready',
          clothId: cloth.id,
          sourceAssetId: cloth.visualMapping.assetId,
          textureSupportAssetId: feltTexture.assetId,
          textureSupportResolution: `${feltTexture.width}x${feltTexture.height}`,
          exactSourceCrop: 'false',
          enlargedLowResolutionCrop: 'false',
          materialOnly: 'true',
          catalogColor: cloth.visualMapping.color,
          verifiedColor: feltTargetHex,
          colorMapping: 'robust-official-render-bed-sample-lab-normalized-texture',
          sourceTargetLab: labString(feltTarget.lab),
          detailRepresentativeLab: labString(feltCalibration.representative),
          colorDeltaE76: feltCalibration.deltaE.toFixed(4),
          colorDeltaEThreshold: String(DETAIL_COLOR_DELTA_E_MAX),
          sourceSampleCount: String(feltTarget.retainedCount),
          samplingMethod: feltTarget.method,
          generatedSupportTexture: 'true'
        });

        if (!sightEvidence.available) {
          this.clearSightDetail(sightEvidence.reason);
          return;
        }
        this.sightCard.hidden = false;
        if (this.sightDetail.width !== 384 || this.sightDetail.height !== 384) {
          this.sightDetail.width = 384;
          this.sightDetail.height = 384;
        }
        const railTarget = this.finishRailSourceTarget(finishImage, finish.visualMapping.assetUrl);
        const railCalibration = this.paintSourceMatchedTexture(
          this.sightDetail,
          railTextureImage,
          railTarget.lab,
          railTop.assetUrl
        );
        const sightBounds = this.alphaBounds(sightImage, sightAssetUrl);
        const sightContext = this.sightDetail.getContext('2d');
        const sightMaxAxis = Math.round(Math.min(this.sightDetail.width, this.sightDetail.height) * SIGHT_DETAIL_MAX_AXIS_RATIO);
        const sightScale = sightMaxAxis / Math.max(sightBounds.width, sightBounds.height);
        const sightWidth = Math.max(1, Math.round(sightBounds.width * sightScale));
        const sightHeight = Math.max(1, Math.round(sightBounds.height * sightScale));
        sightContext.imageSmoothingEnabled = true;
        sightContext.imageSmoothingQuality = 'high';
        sightContext.drawImage(
          sightImage,
          sightBounds.x,
          sightBounds.y,
          sightBounds.width,
          sightBounds.height,
          Math.round(SIGHT_DETAIL_OVERLAY_CENTER.x - sightWidth / 2),
          Math.round(SIGHT_DETAIL_OVERLAY_CENTER.y - sightHeight / 2),
          sightWidth,
          sightHeight
        );
        this.sightDetail.setAttribute('data-finish-background-asset-id', finish.visualMapping.assetId);
        const fixedSightCopy = this.contract?.fixedSight ? ' fixed supplied' : '';
        this.sightDetail.setAttribute('aria-label', `${finish.label} straight-down illustrative rail detail calibrated to representative top-rail pixels from the exact selected official ${this.model.product.title} finish render, with one centered enlarged${fixedSightCopy} ${sights.label} official sight reference. It is a material-and-shape detail, not installed placement or scale.`);
        this.detailSightCaption.textContent = sights.label;
        Object.assign(this.sightCard.dataset, {
          renderStatus: 'ready',
          finishId: finish.id,
          sightId: sights.id,
          sourceAssetId: sights.visualMapping.assetId,
          finishBackgroundAssetId: finish.visualMapping.assetId,
          finishBackgroundMode: 'purpose-built-straight-down-support-lab-normalized-to-selected-finish',
          finishBackgroundCrop: 'none',
          finishBackgroundGenerated: 'true',
          finishBackgroundWarped: 'false',
          finishBackgroundResized: 'false',
          finishBackgroundSourceProductId: this.model.eligibility.sourceProductId,
          sourceSightSuppression: 'not-applicable-support-contains-no-source-sight-marks',
          sourceSightSuppressionCount: '0',
          railSupportAssetId: railTop.assetId,
          positionCount: '1',
          detailMode: 'single-enlarged-illustrative',
          originalSourceSightMarks: 'none',
          originalSightMarksCovered: 'true',
          sightPlane: 'straight-down-top-only',
          verticalRailFace: 'false',
          fullProductComposited: 'false',
          placementIllustrative: 'true',
          installedScaleClaimed: 'false',
          railPresentation: 'purpose-built-straight-down-support-lab-normalized-to-official-top-rail',
          warpedObliqueSource: 'false',
          finishTintSourceAssetId: finish.visualMapping.assetId,
          finishColorMapping: 'robust-official-render-top-rail-sample-lab-normalized-texture',
          samplingMethod: railTarget.method,
          sourceTargetLab: labString(railTarget.lab),
          detailRepresentativeLab: labString(railCalibration.representative),
          colorDeltaE76: railCalibration.deltaE.toFixed(4),
          colorDeltaEThreshold: String(DETAIL_COLOR_DELTA_E_MAX),
          sourceSampleCount: String(railTarget.retainedCount),
          sightMaxAxisPixels: String(sightMaxAxis),
          sightMaxAxisToCanvasRatio: String(SIGHT_DETAIL_MAX_AXIS_RATIO),
          sightRenderedWidthPixels: String(sightWidth),
          sightRenderedHeightPixels: String(sightHeight),
          sightAspectRatioPreserved: 'true',
          sightScalePurpose: 'detail-magnification-not-installed-scale'
        });
        if (this.contract?.fixedSight) this.sightCard.dataset.fixedOfficialOption = 'true';
      } catch (error) {
        if (renderToken !== this.detailRenderToken) return;
        [this.feltDetail, ...(this.pocketVisualEnabled ? [this.pocketDetail] : [])].forEach((canvas) => canvas.getContext('2d').clearRect(0, 0, canvas.width, canvas.height));
        [[this.feltCard, 'classicFeltCard'], ...(this.pocketVisualEnabled ? [[this.pocketCard, 'classicPocketCard']] : [])].forEach(([card, preservedKey]) => {
          for (const key of Object.keys(card.dataset)) {
            if (key !== preservedKey) delete card.dataset[key];
          }
          card.dataset.renderStatus = 'unavailable';
        });
        this.clearSightDetail('render_error');
        if (this.pocketVisualEnabled) this.pocketCaption.textContent = 'Pocket detail unavailable';
        this.detailFeltCaption.textContent = 'Felt detail unavailable';
        if (this.pocketVisualEnabled) this.pocketDetail.setAttribute('aria-label', 'Pocket detail unavailable; use the exact selected pocket label for the quote.');
        this.feltDetail.setAttribute('aria-label', 'Felt detail unavailable; use the selected exact cloth label for the quote.');
      }
    }

    selectedValue(optionId) {
      const option = this.model.options?.find((item) => item.id === optionId);
      return option?.values.find((value) => (
        value.id === this.state[optionId]
        && value.eligible === true
        && !this.isCompatibilityBlocked(optionId, value.id)
      ));
    }

    isCompatibilityBlocked(optionId, valueId) {
      return (this.model.compatibilityRules || []).some((rule) => (
        this.state[rule.when?.optionId] === rule.when?.valueId
        && rule.blocks?.some((blocked) => blocked.optionId === optionId && blocked.valueId === valueId)
      ));
    }

    reconcileCompatibility() {
      this.model.options?.forEach((option) => {
        if (!this.isCompatibilityBlocked(option.id, this.state[option.id])) return;
        const replacement = option.values.find((value) => value.eligible === true && !this.isCompatibilityBlocked(option.id, value.id));
        if (replacement) this.state[option.id] = replacement.id;
      });
    }

    syncCompatibilityControls() {
      this.querySelectorAll('[data-option-id][value]').forEach((control) => {
        const optionId = control.dataset.optionId;
        const blocked = this.isCompatibilityBlocked(optionId, control.value);
        control.disabled = blocked || control.dataset.eligible === 'false';
        control.setAttribute('aria-disabled', String(control.disabled));
        if ('checked' in control) control.checked = this.state[optionId] === control.value;
      });
      this.querySelectorAll('[data-classic-size-select]').forEach((select) => {
        select.value = this.state['table-size'];
      });
      this.querySelectorAll('[data-compatibility-note]').forEach((note) => {
        note.hidden = this.state['table-size'] !== '7-ft';
      });
    }

    renderOptions() {
      this.optionGroups?.replaceChildren();
      this.visualOptionGroups?.replaceChildren();

      const unifiedClassicLayout = this.classList.contains('classic-builder--layout-pilot');
      const optionOrder = unifiedClassicLayout
        ? ['table-size', 'finish', 'pockets', 'cloth', 'sights', 'drawer']
        : ['table-size', 'finish', 'pockets', 'drawer', 'cloth', 'sights'];
      const appendOptionGroup = (option, fieldset) => {
        const isVisualControl = ['cloth', 'sights'].includes(option.id);
        const target = unifiedClassicLayout || isVisualControl ? this.visualOptionGroups : this.optionGroups;
        target?.append(fieldset);
        if (unifiedClassicLayout && option.id === 'finish' && this.fixedPocketVisualEnabled && this.pocketCard) {
          const pocketGroup = document.createElement('section');
          const pocketHeading = document.createElement('h3');
          const pocketDescription = document.createElement('p');
          const pocketHeadingId = `${this.id}-fixed-pocket-heading`;
          pocketGroup.className = 'classic-builder__option-group classic-builder__fixed-pocket-option';
          pocketGroup.dataset.fixedPocketOption = '';
          pocketGroup.setAttribute('aria-labelledby', pocketHeadingId);
          pocketHeading.id = pocketHeadingId;
          pocketHeading.className = 'classic-builder__fixed-pocket-heading';
          pocketHeading.textContent = 'Pocket';
          pocketDescription.className = 'classic-builder__sr-only';
          pocketDescription.textContent = `Fixed ${this.fixedPocketDetail.construction} construction; not a selectable option.`;
          pocketGroup.append(pocketHeading, pocketDescription, this.pocketCard);
          target.append(pocketGroup);
        }
      };
      optionOrder
        .map((optionId) => this.model.options?.find((option) => option.id === optionId))
        .filter(Boolean)
        .forEach((option) => {
        const fieldset = document.createElement('fieldset');
        const legend = document.createElement('legend');
        const legendRow = document.createElement('span');
        const legendLabel = document.createElement('strong');
        const kind = document.createElement('span');
        const choices = document.createElement('div');

        fieldset.className = 'classic-builder__option-group';
        fieldset.dataset.optionId = option.id;
        legendRow.className = 'classic-builder__legend-row';
        kind.className = 'classic-builder__kind';
        choices.className = `classic-builder__choices${option.presentation === 'swatch' ? ' classic-builder__choices--swatch' : ''}`;
        legendLabel.textContent = option.label;
        const kindLabel = this.optionKindLabel(option);
        legendRow.append(legendLabel);
        if (kindLabel) {
          kind.textContent = kindLabel;
          legendRow.append(kind);
        }
        legend.append(legendRow);
        fieldset.append(legend);

        if (option.id === 'table-size') {
          const availableSizes = option.values.filter((value) => value.eligible === true);

          if (availableSizes.length === 1) {
            const availability = document.createElement('p');
            availability.className = 'classic-builder__size-availability';
            availability.dataset.classicFixedSize = '';
            availability.textContent = `Available in ${availableSizes[0].label}`;
            availability.setAttribute('aria-label', `${option.label}: Available in ${availableSizes[0].label}`);
            choices.className = 'classic-builder__size-availability-wrap';
            choices.append(availability);
            fieldset.append(choices);
            appendOptionGroup(option, fieldset);
            return;
          }

          const select = document.createElement('select');
          select.className = 'classic-builder__select';
          select.dataset.classicSizeSelect = '';
          select.required = option.required === true;
          select.setAttribute('aria-label', option.label);
          availableSizes.forEach((value) => {
            const selectOption = document.createElement('option');
            selectOption.value = value.id;
            selectOption.textContent = value.label;
            selectOption.disabled = value.eligible !== true;
            selectOption.selected = this.state[option.id] === value.id;
            selectOption.dataset.quoteConfirmation = String(value.quoteConfirmation === true);
            select.append(selectOption);
          });
          select.addEventListener('change', () => {
            const value = option.values.find((candidate) => candidate.id === select.value && candidate.eligible === true);
            if (!value) return;
            this.state[option.id] = value.id;
            this.update({ applyPreview: true });
          });
          choices.className = 'classic-builder__select-wrap';
          choices.append(select);
          fieldset.append(choices);
          appendOptionGroup(option, fieldset);
          return;
        }

        if (option.id === 'drawer') {
          const noValue = option.values.find((value) => value.id === 'no' && value.eligible === true);
          const yesValue = option.values.find((value) => value.id === 'yes' && value.eligible === true);

          if (noValue && yesValue && option.values.length === 2) {
            const toggleLabel = document.createElement('label');
            const toggleInput = document.createElement('input');
            const toggleCopy = document.createElement('span');

            choices.className = 'classic-builder__drawer-control';
            toggleLabel.className = 'classic-builder__drawer-toggle';
            toggleInput.type = 'checkbox';
            toggleInput.id = `${this.id}-drawer-yes`;
            toggleInput.value = yesValue.id;
            toggleInput.dataset.optionId = option.id;
            toggleInput.dataset.eligible = String(yesValue.eligible === true);
            toggleInput.dataset.classicDrawerToggle = '';
            toggleInput.checked = this.state[option.id] === yesValue.id;
            toggleInput.disabled = noValue.eligible !== true || yesValue.eligible !== true;
            toggleLabel.htmlFor = toggleInput.id;
            toggleCopy.textContent = 'Add matching drawer';
            toggleLabel.append(toggleInput, toggleCopy);
            choices.append(toggleLabel);

            const drawerRule = (this.model.compatibilityRules || []).find((rule) => (
              rule.blocks?.some((blocked) => blocked.optionId === 'drawer' && blocked.valueId === 'yes')
            ));
            if (drawerRule) {
              const availability = document.createElement('small');
              availability.className = 'classic-builder__availability-note';
              availability.dataset.compatibilityNote = drawerRule.id;
              availability.textContent = drawerRule.reason;
              availability.hidden = this.state['table-size'] !== drawerRule.when?.valueId;
              choices.append(availability);
            }

            fieldset.append(choices);
            appendOptionGroup(option, fieldset);

            toggleInput.addEventListener('change', () => {
              this.state[option.id] = toggleInput.checked ? yesValue.id : noValue.id;
              this.update({ applyPreview: true });
            });
            return;
          }
          return;
        }

        if (['pockets', 'cloth', 'sights'].includes(option.id) || (unifiedClassicLayout && option.id === 'finish')) {
          choices.classList.add('classic-builder__choices--compact-rail');
          choices.setAttribute('aria-label', `${option.label} choices; horizontally scrollable when needed`);
        }

        option.values.forEach((value) => {
          const choice = document.createElement('div');
          const input = document.createElement('input');
          const label = document.createElement('label');
          const copy = document.createElement('span');
          const text = document.createElement('span');
          const inputId = `${this.id}-${option.id}-${value.id}`;

          choice.className = `classic-builder__choice${['pockets', 'cloth', 'sights'].includes(option.id) ? ' classic-builder__choice--compact' : ''}${option.id === 'pockets' ? ' classic-builder__choice--pocket' : ''}${unifiedClassicLayout && option.id === 'finish' ? ' classic-builder__choice--finish-rail' : ''}`;
          input.type = 'radio';
          input.id = inputId;
          input.name = `${this.id}-${option.id}`;
          input.value = value.id;
          input.dataset.optionId = option.id;
          input.dataset.eligible = String(value.eligible === true);
          input.checked = this.state[option.id] === value.id;
          input.disabled = value.eligible !== true;
          input.required = option.required === true;
          label.htmlFor = inputId;
          copy.className = 'classic-builder__choice-copy';
          text.textContent = value.label;

          if (option.presentation === 'swatch' && value.color) {
            const swatch = document.createElement('span');
            swatch.className = 'classic-builder__swatch';
            swatch.style.setProperty('--classic-swatch', value.color);
            label.append(swatch);
          } else if (option.presentation === 'image_grid' && value.visualMapping?.assetUrl) {
            const image = document.createElement('img');
            image.className = `classic-builder__choice-image classic-builder__choice-image--${option.id}`;
            image.src = value.visualMapping.assetUrl;
            image.alt = '';
            image.loading = 'lazy';
            image.width = ['pockets', 'sights'].includes(option.id) ? 72 : 120;
            image.height = ['pockets', 'sights'].includes(option.id) ? 72 : 56;
            label.append(image);
          }

          copy.append(text);
          label.append(copy);
          choice.append(input, label);
          choices.append(choice);

          input.addEventListener('change', () => {
            if (!input.checked) return;
            this.state[option.id] = value.id;
            this.update({ applyPreview: true });
          });
        });

        fieldset.append(choices);
        appendOptionGroup(option, fieldset);
      });

      if (unifiedClassicLayout && this.quoteSlot) {
        (this.quoteWorkspace || this.visualOptionGroups)?.append(this.quoteSlot);
        this.quoteSlot.dataset.placement = 'workspace-bottom-right';
        return;
      }

      const finishGroup = this.optionGroups?.querySelector('[data-option-id="finish"]');
      const drawerGroup = this.optionGroups?.querySelector('[data-option-id="drawer"]');
      const quoteAnchor = drawerGroup || finishGroup;
      if (quoteAnchor && this.quoteSlot) {
        quoteAnchor.insertAdjacentElement('afterend', this.quoteSlot);
        this.quoteSlot.dataset.placement = drawerGroup ? 'after-drawer' : 'after-finish';
      }
    }

    updateFixedDetailNotes() {
      const updateNote = (optionId, card, note, noun) => {
        if (!card || !note) return;
        const option = this.model.options?.find((candidate) => candidate.id === optionId);
        const eligibleValues = option?.values?.filter((value) => value.eligible === true) || [];
        if (eligibleValues.length !== 1) {
          note.hidden = true;
          note.textContent = '';
          delete card.dataset.fixedOfficialOption;
          return;
        }
        note.textContent = `Only available ${noun}: ${eligibleValues[0].label}.`;
        note.hidden = false;
        card.dataset.fixedOfficialOption = 'true';
      };

      updateNote('cloth', this.feltCard, this.feltFixedNote, 'felt');
      if (this.contract?.fixedSight && this.sightCard && this.sightFixedNote) {
        this.sightFixedNote.textContent = `Only available sight: ${this.contract.fixedSight.label}.`;
        this.sightFixedNote.hidden = false;
        this.sightCard.dataset.fixedOfficialOption = 'true';
      } else {
        updateNote('sights', this.sightCard, this.sightFixedNote, 'sight');
      }
    }

    optionKindLabel(option) {
      if (option.id === 'finish') return 'Product image';
      if (option.id === 'pockets' || option.id === 'cloth' || option.id === 'sights') return '';
      return 'Quote only';
    }

    selectionStatus(optionId) {
      if (optionId === 'finish') return 'Previewed in official product image';
      if (optionId === 'pockets') return 'Previewed in the exact selected-finish corner with the selected felt behind the installed official pocket';
      if (optionId === 'cloth') return 'Previewed with official felt layer';
      if (optionId === 'sights') return 'Official material/style reference in a straight-down illustrative detail calibrated to the selected finish';
      if (optionId === 'drawer' && this.selectedValue('drawer')?.id === 'yes') {
        const finish = this.selectedValue('finish');
        return finish && this.model.drawerPreviewEvidence?.finishMappings?.[finish.id]
          ? 'Previewed with an exact aligned model- and finish-matched open-drawer layer'
          : 'Quote-only; no exact aligned finish-matched open-drawer layer is available';
      }
      return 'Quote-only; not previewed';
    }

    update({ applyPreview }) {
      this.reconcileCompatibility();
      this.syncCompatibilityControls();
      const errors = [...this.catalogErrors];
      this.model.options?.forEach((option) => {
        if (option.required === true && !this.selectedValue(option.id)) errors.push(`missing:${option.id}`);
      });

      this.updateSelectedSurfaces();
      this.updateSummary();

      if (applyPreview && this.viewerReady) {
        try {
          this.applyPreviewMappings();
        } catch (error) {
          errors.push('viewer_mapping_failed');
          this.fail('The preview could not be updated. Please reload and try again.');
          return;
        }
      } else if (!this.viewerReady) {
        errors.push(this.viewerFailed ? 'viewer_unavailable' : 'viewer_not_ready');
      }

      this.currentConfiguration = this.createConfiguration(errors);
      this.validationStatus.textContent = errors.length === 0 ? '' : (this.viewerFailed ? 'Preview unavailable' : 'Preparing preview');
      this.useButton.disabled = errors.length > 0;

      if (errors.length === 0) {
        this.commitConfiguration({ focusQuote: false, announce: false });
      }

      try {
        sessionStorage.setItem(this.storageKey(), JSON.stringify(this.state));
      } catch (error) {
        this.dataset.storageUnavailable = 'true';
      }
    }

    applyPreviewMappings() {
      const finish = this.selectedValue('finish');
      const cloth = this.selectedValue('cloth');
      const pockets = this.selectedValue('pockets');
      const sights = this.selectedValue('sights') || (this.contract?.fixedSight && this.model.fixedSightDetail
        ? { ...this.contract.fixedSight, visualMapping: this.model.fixedSightDetail }
        : null);

      if (
        !finish?.visualMapping?.assetUrl
        || !cloth?.visualMapping?.assetUrl
        || !cloth?.visualMapping?.color
        || !sights?.visualMapping?.assetUrl
      ) {
        throw new Error('Missing visual reference');
      }

      this.finishReference.src = finish.visualMapping.assetUrl;
      void this.updateDrawerPreview(finish).catch(() => {
        this.dataset.drawerPreviewFailed = 'true';
        this.drawerLayer?.setAttribute('data-visible', 'false');
      });
      const pocketBacking = finish.visualMapping.pocketBacking;
      if (pocketBacking) {
        if (!this.pocketUnderlay) throw new Error('Missing pocket underlay element');
        this.pocketUnderlay.src = pocketBacking.assetUrl;
        this.pocketUnderlay.hidden = false;
        this.pocketUnderlay.dataset.finishId = finish.id;
        this.pocketUnderlay.dataset.sourceMethod = pocketBacking.method;
      } else if (this.pocketUnderlay) {
        this.pocketUnderlay.hidden = true;
        this.pocketUnderlay.removeAttribute('src');
        delete this.pocketUnderlay.dataset.finishId;
        delete this.pocketUnderlay.dataset.sourceMethod;
      }
      const drawer = this.selectedValue('drawer');
      const drawerEvidence = this.model.drawerPreviewEvidence;
      const drawerPreviewAvailable = drawer?.id === 'yes'
        && drawerEvidence?.perFinishMappingsComplete === true
        && Boolean(drawerEvidence.finishMappings?.[finish.id]);
      const drawerDescription = drawer?.id === 'yes'
        ? (drawerPreviewAvailable
          ? ' The selected matching drawer is previewed with an exact model- and finish-matched official open-drawer render.'
          : ' A matching drawer is selected for the quote, but no exact aligned finish-matched open-drawer layer is available.')
        : '';
      this.finishReference.alt = (pocketBacking
        ? `Official Olhausen ${this.model.product.title} render in ${finish.label} finish with ${cloth.label} felt previewed on the verified bed region. The fixed official pocket pixels are preserved over source-derived ${finish.label} support in their transparent openings. Sight placement is not composited.`
        : `Official Olhausen ${this.model.product.title} render in ${finish.label} finish with ${cloth.label} felt previewed on the verified bed region. Sight placement and pocket color are not composited.`) + drawerDescription;
      this.feltLayer.src = cloth.visualMapping.assetUrl;
      this.feltLayer.alt = '';
      const feltClipAssetUrl = finish.visualMapping.feltClipAssetUrl;
      if (feltClipAssetUrl) {
        const feltClipCssUrl = `url("${feltClipAssetUrl.replaceAll('"', '\\"')}")`;
        this.feltLayer.style.webkitMaskImage = feltClipCssUrl;
        this.feltLayer.style.maskImage = feltClipCssUrl;
        this.feltLayer.dataset.clipMode = 'exact_finish_alpha_topology';
      } else {
        this.feltLayer.style.removeProperty('-webkit-mask-image');
        this.feltLayer.style.removeProperty('mask-image');
        delete this.feltLayer.dataset.clipMode;
      }
      void this.renderDetailCards(finish, cloth, sights);
      const sightDetailDescription = this.sightDetailEvidence().available
        ? ` The ${sights.label} tile uses a purpose-built straight-down rail-top support calibrated to representative pixels from this exact selected ${finish.label} finish render and adds one enlarged exact ${this.contract?.fixedSight ? 'fixed supplied ' : ''}sight reference as an illustrative material detail—not installed placement or scale.`
        : ` The sight detail tile is unavailable because the exact official finish source cannot support a truthful contextual crop; the exact ${sights.label} reference remains in the selector and quote payload.`;
      const pocketDetailDescription = this.selectablePocketVisualEnabled
        ? ` The ${pockets.label} pocket tile combines this exact selected-finish corner and ${cloth.label} felt with only the exact official pocket asset placed in the model's source-reviewed corner position. It does not claim complete six-pocket placement on the main product image.`
        : this.fixedPocketVisualEnabled
        ? ` The pocket tile is the official Olhausen ${this.fixedPocketDetail.label} reference for the model's verified fixed leather-pocket construction; the selected finish render remains the source for installed appearance, and no Pocket selector is exposed.`
        : ' Pocket appearance remains fixed from the selected official finish render; no Pocket selector or Pocket detail card is exposed.';
      this.viewerStatus.textContent = `${finish.label} and ${cloth.label} are shown with exact aligned official ${this.model.product.title} imagery; the finish render defines the rail edge over the felt underlay.${pocketBacking ? ` The fixed official pocket pixels are preserved, with only their transparent openings supported by a robust color sampled from this exact ${finish.label} render so the page background cannot bleed through.` : ''}${drawerDescription} The sharp felt tile normalizes its neutral support texture to a robust representative color sampled from the exact visible ${cloth.label} bed pixels.${sightDetailDescription} The full product image does not render sight placement.${pocketDetailDescription}`;
    }

    async updateDrawerPreview(finish) {
      if (!this.drawerLayer) return;
      const token = ++this.drawerPreviewToken;
      const drawer = this.selectedValue('drawer');
      const evidence = this.model.drawerPreviewEvidence;
      const mapping = evidence?.finishMappings?.[finish.id];
      const shouldPreview = drawer?.id === 'yes'
        && evidence?.openPreviewAvailable === true
        && evidence?.perFinishMappingsComplete === true
        && evidence?.mappingMode === 'exact_model_finish_aligned_open_drawer_crossfade'
        && mapping;

      this.drawerLayer.dataset.visible = 'false';
      if (!shouldPreview) {
        this.drawerLayer.dataset.previewStatus = drawer?.id === 'yes' ? 'quote-only' : 'off';
        window.setTimeout(() => {
          if (token !== this.drawerPreviewToken || this.drawerLayer.dataset.visible === 'true') return;
          this.drawerLayer.hidden = true;
          this.drawerLayer.removeAttribute('src');
          delete this.drawerLayer.dataset.finishId;
        }, 180);
        return;
      }

      await this.loadVisualImage(mapping.assetUrl);
      if (token !== this.drawerPreviewToken) return;
      this.drawerLayer.src = mapping.assetUrl;
      this.drawerLayer.hidden = false;
      this.drawerLayer.dataset.finishId = finish.id;
      this.drawerLayer.dataset.previewStatus = 'exact-model-finish-aligned';
      requestAnimationFrame(() => requestAnimationFrame(() => {
        if (token === this.drawerPreviewToken) this.drawerLayer.dataset.visible = 'true';
      }));
    }

    updateSelectedSurfaces() {
      if (!this.selectedSurfaces) return;
      this.selectedSurfaces.replaceChildren();

      ['finish', ...(this.selectablePocketVisualEnabled ? ['pockets'] : []), 'cloth', 'sights'].forEach((optionId) => {
        const option = this.model.options.find((item) => item.id === optionId);
        const value = this.selectedValue(optionId);
        const chip = document.createElement('span');
        const dot = document.createElement('i');
        const copy = document.createElement('span');
        const status = document.createElement('small');

        chip.className = `classic-builder__surface-chip classic-builder__surface-chip--${optionId}`;
        dot.style.setProperty('--chip-color', value?.color || '#d6ae73');
        if (['pockets', 'sights'].includes(optionId) && value?.visualMapping?.assetUrl) {
          dot.style.backgroundImage = `url("${value.visualMapping.assetUrl}")`;
        }
        copy.textContent = `${option.label}: ${value?.label || 'Not selected'}`;
        status.textContent = this.selectionStatus(optionId);
        chip.append(dot, copy, status);
        this.selectedSurfaces.append(chip);
      });
    }

    renderFixedDetails() {
      if (!this.fixedDetails) return;
      this.fixedDetails.replaceChildren();

      this.model.product?.fixedFeatures?.forEach((feature) => {
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = feature.label;
        description.textContent = feature.id === 'pockets'
          ? `${feature.value} — fixed independently; color confirmed in quote`
          : `${feature.value} — fixed model detail`;
        this.fixedDetails.append(term, description);
      });
    }

    updateSummary() {
      if (!this.summary) return;
      this.summary.replaceChildren();

      this.model.options?.forEach((option) => {
        const value = this.selectedValue(option.id);
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = option.label;
        description.textContent = `${value?.label || 'Not selected'} — ${this.selectionStatus(option.id)}`;
        this.summary.append(term, description);
      });
    }

    createConfiguration(errors) {
      const selections = this.model.options?.map((option) => {
        const value = this.selectedValue(option.id);
        return {
          optionId: option.id,
          sourceOptionId: option.sourceOptionId,
          optionLabel: option.label,
          kind: option.kind,
          viewerEffect: option.viewerEffect,
          previewPolicy: option.previewPolicy || 'quote_only',
          previewStatus: this.selectionStatus(option.id),
          valueId: value?.id || null,
          valueLabel: value?.label || null,
          sourceLabel: value?.sourceLabel || value?.label || null,
          sourceValueId: value?.sourceValueId || null,
          quoteTier: value?.quoteTier || null,
          initialSelectionProvenance: this.model.defaultEvidence?.[option.id] || null,
          manufacturerDefaultClaimed: this.model.defaultEvidence?.[option.id] === 'manufacturer_base_marker',
          eligible: value?.eligible === true,
          quoteConfirmation: value?.quoteConfirmation === true
        };
      }) || [];
      const fixedDetails = (this.model.product?.fixedFeatures || []).map((feature) => ({ ...feature }));
      const visual = selections.filter((selection) => ['finish', 'cloth'].includes(selection.optionId));
      const references = selections.filter((selection) => ['pockets', 'sights'].includes(selection.optionId));
      const quoteOnly = selections.filter((selection) => ['table-size', 'drawer'].includes(selection.optionId));
      const summary = [
        'VISUAL PREVIEW',
        ...visual.map((selection) => `${selection.optionLabel}: ${selection.valueLabel}`),
        '',
        'REFERENCE SELECTIONS',
        ...references.map((selection) => `${selection.optionLabel}: ${selection.valueLabel}`),
        '',
        'QUOTE-ONLY SELECTIONS',
        ...quoteOnly.map((selection) => `${selection.optionLabel}: ${selection.valueLabel}`),
        '',
        `FIXED ${String(this.model.product?.title || 'MODEL').toUpperCase()} DETAILS`,
        ...fixedDetails.map((feature) => `${feature.label}: ${feature.value}`)
      ].join('\n');

      return {
        payload: {
          payloadVersion: '1.2',
          schemaVersion: this.model.schemaVersion,
          catalogVersion: this.model.catalogVersion,
          prototype: this.dataset.productHandle === 'classic'
            ? 'classic-static-visual-configurator-v5'
            : 'pool-table-static-visual-configurator-v6',
          selectionKey: selections.map((selection) => `${selection.sourceOptionId}:${selection.sourceValueId}`).join('|'),
          product: {
            shopifyProductId: Number(this.dataset.productId),
            handle: this.dataset.productHandle,
            templateSuffix: this.dataset.productTemplate,
            title: this.model.product?.title,
            vendor: this.model.product?.vendor,
            url: this.model.product?.url,
            sourceProductId: this.model.eligibility?.sourceProductId,
            fixedFeatures: fixedDetails
          },
          selections,
          requiresQuoteConfirmation: true,
          confirmationReasons: [
            ...(this.model.compatibilityRules?.length > 0 ? [] : ['pairwise_compatibility_rules_not_provided_by_source']),
            'quote_bridge_receipt_unverified',
            'sight_placement_and_scale_mapping_unavailable',
            ...(this.selectablePocketVisualEnabled ? [] : ['pocket_color_not_provided_by_source'])
          ],
          compatibility: {
            mode: this.model.compatibilityMatrix?.mode,
            sourceProductId: this.model.compatibilityMatrix?.sourceProductId,
            exactValueAllowlistEvaluated: true,
            exactValueAllowlistPassed: true,
            unlistedValuesUnavailable: true,
            blockedPairCount: this.model.compatibilityMatrix?.blockedPairs?.length || 0,
            pairwiseRuleStatus: this.model.compatibilityMatrix?.pairwiseRuleStatus,
            pairwiseCompatibilityPassed: this.model.compatibilityMatrix?.pairwiseCompatibilityPassed
          },
          validation: {
            mode: 'exact_product',
            exactProductMatch: true,
            catalogValidatedAt: this.model.eligibility?.validatedAt,
            policy: this.model.validation,
            passed: errors.length === 0,
            errors
          },
          viewer: {
            mode: 'static_authorized_aligned_finish_and_felt_layers',
            customerFacing3D: false,
            dragEnabled: false,
            rotationEnabled: false,
            assetId: `${this.dataset.productHandle}-authorized-aligned-finish-and-felt-composite`,
            productionReady: false,
            visualMappings: ['authorized_finish_product_image', 'authorized_aligned_felt_underlay'],
            supportingReferences: [
              ...(this.selectablePocketVisualEnabled ? ['verified_official_pocket_detail_reference'] : []),
              'verified_sight_detail_reference',
              'illustrative_two_position_straight_down_rail_detail'
            ],
            fixedAppearance: fixedDetails.map((feature) => feature.id),
            appearanceIndependence: { pocketsFollowFinish: false },
            blockedVisualMappings: [
              'sight_full_product_placement_scale_and_installation_fit_unavailable',
              ...(this.selectablePocketVisualEnabled ? ['pocket_full_product_placement_scale_and_installation_fit_unavailable'] : ['pocket_color_choice_not_provided'])
            ]
          },
          verification: this.model.verification,
          sources: this.model.sources,
          dataGaps: this.model.gaps
        },
        summary
      };
    }

    commitConfiguration({ focusQuote = true, announce = true } = {}) {
      const current = this.currentConfiguration;
      if (!current?.payload?.validation?.passed) {
        this.fail(`Complete the verified ${this.model.product?.title || 'pool table'} configuration before saving it to the quote.`);
        return;
      }

      const committed = {
        payload: {
          ...current.payload,
          commit: {
            configurationId: globalThis.crypto?.randomUUID?.() || `${this.dataset.productId}-${Date.now()}`,
            committedAt: new Date().toISOString(),
            integrity: 'client_generated_untrusted'
          }
        },
        summary: current.summary
      };
      const payloadBytes = new TextEncoder().encode(JSON.stringify(committed.payload)).length;
      const summaryBytes = new TextEncoder().encode(committed.summary).length;

      if (payloadBytes > 60000 || summaryBytes > 10000) {
        this.fail(`The ${this.model.product?.title || 'pool table'} configuration exceeded the safe quote payload limit.`);
        return;
      }

      window.badlandsCommittedProductConfigurations = window.badlandsCommittedProductConfigurations || new Map();
      window.badlandsCommittedProductConfigurations.set(`${this.dataset.productId}:${this.dataset.productHandle}`, committed);
      this.dispatchEvent(new CustomEvent('product-configurator:saved', { bubbles: true, detail: committed }));
      this.commitStatus.textContent = announce ? 'Configuration saved with visual, reference-only, and quote-only labels preserved.' : '';

      if (!focusQuote) return;

      const quotePanel = document.getElementById(this.dataset.quotePanelId);
      quotePanel?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setTimeout(() => quotePanel?.querySelector('input:not([type="hidden"]), textarea, button')?.focus({ preventScroll: true }), 450);
    }

    fail(message) {
      this.viewerFailed = true;
      this.viewerReady = false;
      this.error.hidden = false;
      this.error.textContent = message;
      this.viewerStatus.textContent = message;
      this.validationStatus.textContent = 'Preview unavailable';
      this.useButton.disabled = true;
      this.stage?.setAttribute('aria-busy', 'false');
    }
  }

  if (!customElements.get('classic-builder-prototype')) {
    customElements.define('classic-builder-prototype', ClassicBuilderPrototype);
  }
  if (!customElements.get('pool-table-visual-builder')) {
    customElements.define('pool-table-visual-builder', class PoolTableVisualBuilder extends ClassicBuilderPrototype {});
  }
})();
